import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import Tabs from "../../../components/tabs";
import TabPanel from "../../../components/tabs/tabpanel";
import Upcoming from "./upcoming";
import Cancelled from "./cancelled";
import Completed from "./completed";
import axios from "axios";

import { list, filterList } from "./data";
import Search from "../../../components/search";
import Button from "../../../components/button";
import Pusher from "pusher-js";

//
import {
  setAllAppointments,
  setAllUpcomingCount,
  setAllCompletedCount,
  setAllCancelledCount,
  setAllNoShowCount,
  setAllOngoingCount,
  setUpcomingAppointmentsPage,
  setUpcomingAppointmentsrowsPerPage,
  setCompletedAppointmentsPage,
  setCompletedAppointmentsrowsPerPage,
  setCancelledAppointmentsPage,
  setCancelledAppointmentsrowsPerPage,
  setNoShowAppointmentsPage,
  setNoShowAppointmentsrowsPerPage,
  setAllRestrictedCount,
  setEndedEarlyCount,
  setrestrictedAppointmentsPage,
  setrestrictedAppointmentsrowsPerPage,
  setendedEarlyAppointmentsPage,
  setendedEarlyAppointmentsrowsPerPage,
  setSessionTypes,
} from "../../../reducer/adminSlice";
import { setLoading } from "../../../reducer/auth/auth";

//service
import {
  getAllAppointments,
  changeAppointmentStatus,
  filterAllAppointments,
  getAllUpComingAppointments,
  getAllOngoingAppointments,
  getAllNoShowsAppointments,
  getAllUpCancelledAppointments,
  getAllCompletedAppointments,
  filterAllUpcomingAppointments,
  filterAllCompletedAppointments,
  filterAllCancelleddAppointments,
  filterAllNoShowAppointments,
  filterAllOngoingAppointments,
  getAllRestrictedAppointments,
  getAllEndedEarlyAppointments,
  filterAllRestrictedAppointments,
  filterAllEndedEarlyAppointments,
  exportAppointments,
  exportDownloadAppointments,
  getSessionType,
  updateIncludeExcludeTestAppointments,
  ExportData,
  getAllClients,
  getAllMediums,
  getCreateAppointmentSubseesions,
} from "../../../services/admin";
import CreateNewAppointment from "../Subcomponents/createappointment";
import CreateNewMediumAppointment from "../Subcomponents/createmediumappointment";
import AppointmentConfirmModal from "../../../components/appointmentsConfirmModal";

import "./appointments.css";
import NoShows from "./noshows";
import Ongoing from "./Ongoing";
import { setNewTimeZone } from "../../../services/medium";
import { setNewTimeZoneData } from "../../../reducer/userSlice";
import { setTimezoneArray } from "../../../reducer/uidataSlice";
import { getTimezones, getCountry, getLanguages, } from "../../../services/uidata";
import {
  emptyAllSelectBox,
  filterVisibleTimeZones,
} from "../../../utils/helpers";
import { toast } from "react-toastify";
import RestrictedAppointments from "./restricted";
import EndedEarlyAppointments from "./endedearly";
import { da } from "date-fns/locale";
import { items } from "../calendar/data";
import { useLocation, useSearchParams } from "react-router-dom";
import { get, is } from "immutable";


export default function Appointments() {
  const {
    allUpcomingAppointments,
    allCompletedAppointments,
    allCancelledAppointments,
    allNoShowsAppointments,
    allOngoingAppointments,
    allUpcomingCount,
    allCompletedCount,
    allCancelledCount,
    allNoShowCount,
    allOngoingCount,
    globalRowsPerPage,
    upcomingAppointmentsPage,
    upcomingAppointmentsrowsPerPage,
    completedAppointmentsPage,
    completedAppointmentsrowsPerPage,
    cancelledAppointmentsPage,
    cancelledAppointmentsrowsPerPage,
    noshowAppointmentsPage,
    restrictedAppointmentsPage,
    restrictedAppointmentsrowsPerPage,
    endedEarlyAppointmentsPage,
    endedEarlyAppointmentsrowsPerPage,
    noshowAppointmentsrowsPerPage,
    ongoingAppointmentsPage,
    ongoingAppointmentsrowsPerPage,
    sessionTypes,
  } = useSelector((state) => state.users);
  const { timezone, include_exclude_test_appointments } = useSelector((state) => state.user.user);
  const { timezoneArray } = useSelector((state) => state.uidata);

  const dispatch = useDispatch();
  const [checked, setChecked] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [upcomingAppointment, setUpcomingAppointments] = useState([]);
  const [completedAppointment, setCompletedAppointments] = useState([]);
  const [canceledAppointment, setCanceledAppointments] = useState([]);
  const [showAppointment, setShowAppointments] = useState([]);
  const [restrictedAppontmets, setRestrictedAppontmets] = useState([]);
  const [endedEarlyAppontmets, setEndedEarlyAppontmets] = useState([]);
  const [showOngoingAppointments, setOngoingAppointments] = useState([]);

  const [listArray, setListArray] = useState(list);
  const [backuupcoming, setbackupUpcoming] = useState([]);
  const [backuupcompleted, setbackupCompleted] = useState([]);
  const [backuupcancelled, setbackupCancelled] = useState([]);
  const [backuupnoshow, setbackupUpNoShow] = useState([]);
  const [backuupnongoing, setbackupOngoing] = useState([]);
  const [timezoneData, setTimezoneData] = useState([]);

  const [filterValues, setFilterValues] = useState("screen_name");
  const [searchValue, setSearchValues] = useState("");
  const [searchValueFilter, setSearchValuesFilter] = useState("");

  const [serviceTypeList, setServiceTypeList] = useState([]);
  const [serviceFilterValue, setServiceFilterValue] = useState("");

  const [sortingNameOrderBy, setSortingNameOrderBy] = useState("");
  const [sortingTtabType, setSortingTabType] = useState("");
  const [meetingLinkRegenerated, setmeetingLinkRegenerated] = useState({})
  const [exportDownload, setExportDownload] = useState('');

  const [operatorList, setOperatorList] = useState(["=", "LIKE"]);
  const [optionsList, setOptionsList] = useState([
    { value: "1", name: "Yes" },
    { value: "0", name: "No" },
  ]);
  const [filterValueOptions, setFilterValueOptions] = useState("");
  const [showOprater, setShowOprater] = useState(false);
  const [filterOprater, setFilterOprater] = useState("=");
  const [serviceTypeShow, setServiceTypeShow] = useState(false);
  const [countryData, setCountryData] = useState([]);
  const [tabTrigger, setTabTrigger] = useState(100);
  const [isSearching, setIsSearching] = useState(true);
  const [loadAll, setLoadAll] = useState(false);
  const [isFilterDirty, setIsFilterDirty] = useState(true);
  const filtersRef = useRef({ filterValues: {}, operator: "" });

  const [searchParams] = useSearchParams();
    const status = searchParams.get("view");
    const searchVal = searchParams.get("search");
    const searchName = searchParams.get("searchName");
    const serviceFilterValueData = searchParams.get("serviceFilterValue");
    const searchFilterOprater = searchParams.get("searchFilterOprater");
    const searchOprator = searchParams.get("searchOprator");
    const page = searchParams.get('page');
    const rowperpage = searchParams.get('rowperpage');
    const pagintion = searchParams.get('pagintion');

  useEffect(() => {
    if (!sessionTypes.length) getSessionTypes();
    if (!timezoneArray.length) updateTimezones();
    if (searchVal !== null) {
      setFilterValues(searchVal);
    }
    if (searchName !== null) {
      setSearchValues({ [searchVal]: searchName })
      if (searchVal == "country") {
        
        updateCountries()
          .then((response) => {
            const countries = response.data.data; // <-- access the array here
              console.log(searchName, "searchName data");
              
              const formattedCountryData = countries.map((country) => ({
                value: country.id,
                name: country.country_name
              }));
              
              setOptionsList(formattedCountryData);
              setFilterValueOptions(searchName);

          })
          .catch(err => console.log(err));
      } 
    }
    setTimeout(() => {
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.delete("view");
      newUrl.searchParams.delete("search");
      newUrl.searchParams.delete("searchName");
      newUrl.searchParams.delete("serviceFilterValue");
      newUrl.searchParams.delete("searchFilterOprater");
      newUrl.searchParams.delete("searchOprator");
      newUrl.searchParams.delete("page");
      newUrl.searchParams.delete("rowperpage");
      newUrl.searchParams.delete("pagintion");
      // setQueryValue(newUrl.searchParams.delete("view"))
      window.history.replaceState({}, document.title, newUrl.href);
    
    }, 2000)
     
    
    if(serviceFilterValueData !== null && serviceFilterValueData !== undefined && serviceFilterValueData !== '') {
      let serviceFilterValueNew = JSON.parse(decodeURIComponent(serviceFilterValueData));
      setLoadAll(true);
      let value = serviceFilterValueNew;
       let multiSessionType = '';
       if (searchVal == "created_at" || searchVal == "session_date") {
        setShowOprater(true);
        setOperatorList(['=', 'BETWEEN']);
       }
       
          //setSearchValues(value)
          if (Array.isArray(value)) {
            // Check if "other" exists in the selected values
            //setServiceFilterValue("");
            multiSessionType = value.map(item => item.value).join(',');
        } 
        // Single selection
        else if (value) {
            multiSessionType = value.value; // Store single value
        }
      setServiceFilterValue(serviceFilterValueNew);
      setSearchValuesFilter({session_id: multiSessionType})
      
      if (searchFilterOprater !== null) {
      setFilterOprater(searchFilterOprater)
    }
    }
    console.log(status, "status", searchFilterOprater)
    if (status === "0"){
      setActiveTab(0);
        
     }   
    if (status === "1") setActiveTab(1);
    if (status === "2") setActiveTab(2);
    if (status === "3") setActiveTab(3);
    if (status === "4") setActiveTab(4);
    if (status === "5") setActiveTab(5);
    if (status === "6") setActiveTab(6);
    setTabTrigger(status)
    if (searchName !== null) {
      // dispatch(setLoading(true));
      let searchFilterOpraterVal = searchFilterOprater;
      console.log(searchFilterOpraterVal,"searchFilterOpraterVal")
    setTimeout(() => {
          let data =  {[searchVal]: searchName };
          if (status === "0"){
            setActiveTab(1)
            setActiveTab(0)
        backAPI(data,status,searchFilterOpraterVal);
        }
        }, 2000)
    }else {
      
      launcApi();
       let data1 = {
      page: 1,
      rowsPerPage: 25,
    };
      localStorage.setItem('paginationAppointment', JSON.stringify(data1))
    }

    
    
  }, []);
  const updateCountries = () => {
      return new Promise((resolve, reject) => {
        getCountry()
          .then((data) => {
            if (data.data.status) {
              setCountryData(data.data.data);
            }
            resolve(data);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
  
    };

  useEffect(() => {
    setTimezoneData(filterVisibleTimeZones(timezoneArray));
  }, [timezoneArray]);
  useEffect(() => {
    let info = sessionTypes.filter((data) => {
      if (parseInt(data.sub_session_id) !== 78) {
        return {
          ...data,
        };
      }
    });
    let serviceOptions = info.map((data) => {
      return {
        value: data.sub_session_id,
        label: data.sub_session_name,
      };
    });

    // Frontend-only "Service Type" option grouping the private, paid
    // mediumship/medium session types together as "Paid 1-on-1". Rather than
    // hardcoding sub_session_id's (which are just auto-increment PKs and can
    // differ between staging and live), it's derived from `session_type`:
    //   7  = Mediumship Session (Pay After) family
    //   8  = Medium Session family
    //   12 = Spiritual Mediumship Session
    // These category codes come back from the same get-all-subsession-data
    // response, so this works unmodified on any environment.
    const PAID_ONE_ON_ONE_SESSION_TYPES = [7, 8, 12];
    const paidOneOnOneIds = sessionTypes
      .filter((data) =>
        PAID_ONE_ON_ONE_SESSION_TYPES.includes(parseInt(data.session_type))
      )
      .map((data) => data.sub_session_id)
      .join(",");

    if (paidOneOnOneIds) {
      serviceOptions.push({
        value: paidOneOnOneIds,
        label: "Paid 1-on-1",
      });
    }
    setServiceTypeList(serviceOptions);
  }, [sessionTypes]);
  //////
  const getSessionTypes = () => {
    getSessionType()
      .then((data) => {
        dispatch(setSessionTypes(data.data.data));
      })
      .catch(() => { });
  };
  const checkStatus0Values = (data) => {
  var countStatus = activeTab == 1 ? 1 : 0;

  if (data && Array.isArray(data.attendees)) {
    return data.attendees.filter(function (info) {
      return info.status == countStatus;
    });
  }

  return [];
};

const checkWorkersValues = (data) => {
  var countStatus = activeTab == 1 ? 1 : 0;

  if (data && Array.isArray(data.workers)) {
    return data.workers.filter(function (info) {
      return info.status == countStatus;
    });
  }

  return [];
};
  const backAPI = (dataVal,activeTab, searchFilterOpraterVal =null) => {
    console.log(searchFilterOpraterVal,"searchFilterOpraterVal1")
    let newFilter = null;
    if(serviceFilterValueData !== null && serviceFilterValueData !== undefined && serviceFilterValueData !== '') {
      let serviceFilterValueNew = JSON.parse(decodeURIComponent(serviceFilterValueData));
      let value = serviceFilterValueNew;
       let multiSessionType = '';
          //setSearchValues(value)
          if (Array.isArray(value)) {
            // Check if "other" exists in the selected values
            //setServiceFilterValue("");
            multiSessionType = value.map(item => item.value).join(',');
        } 
        // Single selection
        else if (value) {
            multiSessionType = value.value; // Store single value
        }
     
       newFilter ={session_id: multiSessionType};
    }
     let body = {
 
  screen_name:
    dataVal !== undefined
      ? dataVal.screen_name !== undefined
        ? dataVal.screen_name
        : ""
      : "",
      session_type: dataVal !== undefined
      ? dataVal.session_type !== undefined
        ? dataVal.session_type
        : ""
      : "",
      session_id:   dataVal !== undefined
      ? newFilter.session_id !== null
        ? newFilter.session_id
        : ""
      : "",
  // session_type:
  //   searchValue !== undefined
  //     ? searchValue.session_type !== undefined
  //       ? searchValue.session_type
  //       : ""
  //     : "",
  name:
    dataVal !== undefined
      ? dataVal.name !== undefined
        ? dataVal.name
        : ""
      : "",
  medium_email:
    dataVal !== undefined
      ? dataVal.medium_email !== undefined
        ? dataVal.medium_email
        : ""
      : "",
  client_email:
    dataVal !== undefined
      ? dataVal.client_email !== undefined
        ? dataVal.client_email
        : ""
      : "",
  meeting_id:
    dataVal !== undefined
      ? dataVal.meeting_id !== undefined
        ? dataVal.meeting_id
        : ""
      : "",
  created_at: dataVal !== undefined && dataVal.created_at !== undefined ? dataVal.created_at : '',
  session_date: dataVal !== undefined && dataVal.session_date !== undefined ? dataVal.session_date : '',
  oprater: searchFilterOpraterVal !== undefined && searchFilterOpraterVal !== null && searchFilterOpraterVal !="" ? searchFilterOpraterVal : filterOprater !== undefined ? filterOprater : "=",
  page: 1,
  rowsPerPage:25,
  country: dataVal !== undefined && dataVal.country !== undefined ? dataVal.country : ""
}

   if (activeTab == 0) {
      setLoadAll(true);
    setIsSearching(true);
      getUpComingAppointments(body, status, "loadVal");
    }
    if (activeTab == 1) {
      getCompletedAppointments(body, status);
    }
    if (activeTab == 2) {
      getCancelledAppointments(body, status)
    }
    if (activeTab == 3) {
      getNoShowsAppointments(body, status)
    }
    if (activeTab == 4) {
      getRestrictedAppointments(body, status)
    }
    if (activeTab == 5) {
      getEndedEarlyAppointments(body, status)
    }
    if (activeTab == 6) {
      getOngoingAppointments(body, status)
    }
  }
  const getUpComingAppointments = (data, activeTab,loadVal= null) => {
  
 
    let body = {
  ...data,
  screen_name:
    searchValue !== undefined
      ? searchValue.screen_name !== undefined
        ? searchValue.screen_name
        : ""
      : "",
      session_type: searchValue !== undefined
      ? searchValue.session_type !== undefined
        ? searchValue.session_type
        : ""
      : "",
      session_id:   searchValue !== undefined
      ? searchValueFilter.session_id !== undefined
        ? searchValueFilter.session_id
        : ""
      : "",
  // session_type:
  //   searchValue !== undefined
  //     ? searchValue.session_type !== undefined
  //       ? searchValue.session_type
  //       : ""
  //     : "",
  name:
    searchValue !== undefined
      ? searchValue.name !== undefined
        ? searchValue.name
        : ""
      : "",
  medium_email:
    searchValue !== undefined
      ? searchValue.medium_email !== undefined
        ? searchValue.medium_email
        : ""
      : "",
  client_email:
    searchValue !== undefined
      ? searchValue.client_email !== undefined
        ? searchValue.client_email
        : ""
      : "",
  meeting_id:
    searchValue !== undefined
      ? searchValue.meeting_id !== undefined
        ? searchValue.meeting_id
        : ""
      : "",
  created_at: searchValue !== undefined && searchValue.created_at !== undefined ? searchValue.created_at : '',
  session_date: searchValue !== undefined && searchValue.session_date !== undefined ? searchValue.session_date : '',
  oprater: filterOprater !== undefined ? filterOprater : "",
  country: searchValue !== undefined && searchValue.country !== undefined ? searchValue.country : ""
}
console.log(searchValue.session_date, "pagination body");
 if(activeTab != tabTrigger){

      body = data;
    }
  const filterKeys = [
  "session_type",
  "medium_name",
  "screen_name",
  "orderBy",
  "name",
  "medium_email",
  "client_email",
  "meeting_id",
  "order",
  "created_at",
  "session_date",
  "country",
  "session_id",
    "loadAll"
    
];

// Check if ANY filter has value
const hasAnyFilter = filterKeys.some(key => {
  const value = body[key];
  console.log(key, "=>", value); // Debug each value
  return value !== undefined && value !== null && value.toString().trim() !== "";
});

console.log("hasAnyFilter:", hasAnyFilter);

   if (hasAnyFilter == true || loadAll == true || loadVal !=null) {
    console.log("has filter")
  setIsSearching(true);
  body = {...data, is_count: false};
} else {
   body = {...data, is_count: true};
  setIsSearching(false);
}

console.log(body, "body data")
    getAllUpComingAppointments(body, activeTab)
      .then((data) => {

        if(data.data.data){
           setIsSearching(false);
        }
   if (hasAnyFilter == true || loadAll == true || loadVal !=null) {
        dispatch(
          setAllUpcomingCount(
            JSON.parse(
              JSON.stringify(data.data.data.appointments_count.upcoming)
            )
          )
        );
        dispatch(
          setAllCompletedCount(
            JSON.parse(
              JSON.stringify(data.data.data.appointments_count.completed)
            )
          )
        );
        dispatch(
          setAllCancelledCount(data.data.data.appointments_count.cancelled)
        );
        dispatch(setAllNoShowCount(data.data.data.appointments_count.noshow));
        dispatch(setAllOngoingCount(data.data.data.appointments_count.ongoing));
        dispatch(
          setAllRestrictedCount(data.data.data.appointments_count.restrict)
        );
        dispatch(
          setEndedEarlyCount(data.data.data.appointments_count.endearly)
        );
           
            setUpcomingAppointments(
              data.data.data.info.map((data) => {
                return {
                  ...data,
                  statusValue: "",
                  nostatusValue: "",
                  noOfAttendees: checkStatus0Values(data),
                  noOfWorkers: checkWorkersValues(data),
                };
              })
            );
          }
        setListArray(
          list.map((item) => {
            if (item.name === "Upcoming") {
              return {
                ...item,
                ...(item.count = data.data.data.appointments_count.upcoming),
              };
            }
            if (item.name === "Completed") {
              return {
                ...item,
                ...(item.count = data.data.data.appointments_count.completed),
              };
            }

            if (item.name === "Cancelled") {
              return {
                ...item,
                ...(item.count = data.data.data.appointments_count.cancelled),
              };
            }

            if (item.name === "No Shows") {
              return {
                ...item,
                ...(item.count = data.data.data.appointments_count.noshow),
              };
            }
            if (item.name === "Restriced") {
              return {
                ...item,
                ...(item.count = data.data.data.appointments_count.restrict),
              };
            }
            if (item.name === "Ended Early") {
              return {
                ...item,
                ...(item.count = data.data.data.appointments_count.endearly),
              };
            }
            if (item.name === "Ongoing") {
              return {
                ...item,
                ...(item.count = data.data.data.appointments_count.ongoing),
              };
            }
          })
        );
      })
       .catch((err) => {
    // Ignore cancelled requests
    if (err && err.canceled) {
      console.log("⛔ Skipping because request was cancelled");
      return; // **important**
    }else{
      setIsSearching(false);
    }
    console.log(err, "errror");
    
  }).finally(() => {
     
        console.log("finally called");
      // setIsSearching(false);// loader ALWAYS turns off after API completes
    });
  };

  const getCompletedAppointments = (data, activeTab) => {
   // dispatch(setLoading(true));
    console.log(data);
let body = {
  ...data,
  screen_name:
    searchValue !== undefined
      ? searchValue.screen_name !== undefined
        ? searchValue.screen_name
        : ""
      : "",
      session_type: searchValue !== undefined
      ? searchValue.session_type !== undefined
        ? searchValue.session_type
        : ""
      : "",
      session_id:   searchValue !== undefined
      ? searchValueFilter.session_id !== undefined
        ? searchValueFilter.session_id
        : ""
      : "",
  // session_type:
  //   searchValue !== undefined
  //     ? searchValue.session_type !== undefined
  //       ? searchValue.session_type
  //       : ""
  //     : "",
  name:
    searchValue !== undefined
      ? searchValue.name !== undefined
        ? searchValue.name
        : ""
      : "",
  medium_email:
    searchValue !== undefined
      ? searchValue.medium_email !== undefined
        ? searchValue.medium_email
        : ""
      : "",
  client_email:
    searchValue !== undefined
      ? searchValue.client_email !== undefined
        ? searchValue.client_email
        : ""
      : "",
  meeting_id:
    searchValue !== undefined
      ? searchValue.meeting_id !== undefined
        ? searchValue.meeting_id
        : ""
      : "",
  created_at: searchValue !== undefined && searchValue.created_at !== undefined ? searchValue.created_at : '',
  session_date: searchValue !== undefined && searchValue.session_date !== undefined ? searchValue.session_date : '',
  oprater: filterOprater !== undefined ? filterOprater : "",
  country: searchValue !== undefined && searchValue.country !== undefined ? searchValue.country : ""
}
    console.log(body, "body ")
    if(activeTab != tabTrigger){

      body = data;
    }
      const filterKeys = [
  "session_type",
  "medium_name",
   "screen_name",
  "orderBy",
  "name",
  "medium_email",
  "client_email",
  "meeting_id",
  "order",
  "created_at",
  "session_date",
  "country",
  "session_id",
    "loadAll"
];

// Check if ANY filter has value
const hasAnyFilter = filterKeys.some(key =>
  body[key] && body[key].toString().trim() !== ""
);
   if (hasAnyFilter == true || loadAll == true) {
    setIsSearching(true);
    body = {...data, is_count: false};
   } else {
    setIsSearching(false);
    body = {...data, is_count: true};
   }
    getAllCompletedAppointments(body, activeTab)
      .then((data) => {

       if(data.data.data){
           setIsSearching(false);
        }
        if (hasAnyFilter == true || loadAll == true) {
        dispatch(setLoading(false));
        setCompletedAppointments(
          data.data.data.info.map((data) => {
            return {
              ...data,
              statusValue: "",
              nostatusValue: "",
              noOfAttendees: checkStatus0Values(data),
              noOfWorkers: checkWorkersValues(data),
            };
          })
        );
        dispatch(
          setAllUpcomingCount(
            JSON.parse(
              JSON.stringify(data.data.data.appointments_count.upcoming)
            )
          )
        );
        dispatch(
          setAllCompletedCount(
            JSON.parse(
              JSON.stringify(data.data.data.appointments_count.completed)
            )
          )
        );
        dispatch(
          setAllCancelledCount(data.data.data.appointments_count.cancelled)
        );
        dispatch(setAllNoShowCount(data.data.data.appointments_count.noshow));
        dispatch(setAllOngoingCount(data.data.data.appointments_count.ongoing));
        dispatch(
          setAllRestrictedCount(data.data.data.appointments_count.restrict)
        );
        dispatch(
          setEndedEarlyCount(data.data.data.appointments_count.endearly)
        );
      }
        setListArray(
          list.map((item) => {
            if (item.name === "Upcoming") {
              return {
                ...item,
                ...(item.count = data.data.data.appointments_count.upcoming),
              };
            }
            if (item.name === "Completed") {
              return {
                ...item,
                ...(item.count = data.data.data.appointments_count.completed),
              };
            }

            if (item.name === "Cancelled") {
              return {
                ...item,
                ...(item.count = data.data.data.appointments_count.cancelled),
              };
            }

            if (item.name === "No Shows") {
              return {
                ...item,
                ...(item.count = data.data.data.appointments_count.noshow),
              };
            }
            if (item.name === "Restriced") {
              return {
                ...item,
                ...(item.count = data.data.data.appointments_count.restrict),
              };
            }
            if (item.name === "Ended Early") {
              return {
                ...item,
                ...(item.count = data.data.data.appointments_count.endearly),
              };
            }
            if (item.name === "Ongoing") {
              return {
                ...item,
                ...(item.count = data.data.data.appointments_count.ongoing),
              };
            }
          })
        );
      })
      .catch((err) => {
        if (err && err.canceled) {
          console.log("⛔ Skipping because request was cancelled");
      return; // **important**
    }else{
      setIsSearching(false);
    }
    console.log(err, "errror");
      });
  };
  const getCancelledAppointments = (data, activeTab) => {
    //dispatch(setLoading(true));
    let body = {
      ...data,
      screen_name:
        searchValue !== undefined
          ? searchValue.screen_name !== undefined
            ? searchValue.screen_name
            : ""
          : "",
      session_type:
        searchValue !== undefined
          ? searchValue.session_type !== undefined
            ? searchValue.session_type
            : ""
          : "",
      session_id:
        searchValue !== undefined
          ? searchValueFilter.session_id !== undefined
            ? searchValueFilter.session_id
            : ""
          : "",
      // session_type:
      //   searchValue !== undefined
      //     ? searchValue.session_type !== undefined
      //       ? searchValue.session_type
      //       : ""
      //     : "",
      name:
        searchValue !== undefined
          ? searchValue.name !== undefined
            ? searchValue.name
            : ""
          : "",
      medium_email:
        searchValue !== undefined
          ? searchValue.medium_email !== undefined
            ? searchValue.medium_email
            : ""
          : "",
      client_email:
        searchValue !== undefined
          ? searchValue.client_email !== undefined
            ? searchValue.client_email
            : ""
          : "",
      meeting_id:
        searchValue !== undefined
          ? searchValue.meeting_id !== undefined
            ? searchValue.meeting_id
            : ""
          : "",
      created_at:
        searchValue !== undefined && searchValue.created_at !== undefined
          ? searchValue.created_at
          : "",
          session_date: searchValue !== undefined && searchValue.session_date !== undefined ? searchValue.session_date : '',
      oprater: filterOprater !== undefined ? filterOprater : "",
      country:
        searchValue !== undefined && searchValue.country !== undefined
          ? searchValue.country
          : "",
    };
    if(activeTab != tabTrigger){

      body = data;
    }
       const filterKeys = [
  "session_type",
  "medium_name",
   "screen_name",
  "orderBy",
  "name",
  "medium_email",
  "client_email",
  "meeting_id",
  "order",
  "created_at",
  "session_date",
  "country",
  "session_id",
    "loadAll"
];

// Check if ANY filter has value
const hasAnyFilter = filterKeys.some(key =>
  body[key] && body[key].toString().trim() !== ""
);
   if (hasAnyFilter == true || loadAll == true) {
    setIsSearching(true);
    body = {...data, is_count: false};
   } else {
    setIsSearching(false);
    body = {...data, is_count: true};
   }
    getAllUpCancelledAppointments(body, activeTab).then((data) => {
      dispatch(setLoading(false));
      if(data.data.data){
           setIsSearching(false);
        }
         if (hasAnyFilter == true || loadAll == true) {
      setCanceledAppointments(
        data.data.data.info.map((data) => {
          return { ...data, statusValue: "", nostatusValue: "" };
        })
      );
      dispatch(
        setAllUpcomingCount(
          JSON.parse(
            JSON.stringify(data.data.data.appointments_count.upcoming)
          )
        )
        );
        dispatch(
          setAllCompletedCount(
            JSON.parse(
              JSON.stringify(data.data.data.appointments_count.completed)
            )
          )
        );
        dispatch(
          setAllCancelledCount(data.data.data.appointments_count.cancelled)
        );
        dispatch(setAllNoShowCount(data.data.data.appointments_count.noshow));
        dispatch(setAllOngoingCount(data.data.data.appointments_count.ongoing));
        dispatch(
          setAllRestrictedCount(data.data.data.appointments_count.restrict)
        );
        dispatch(
          setEndedEarlyCount(data.data.data.appointments_count.endearly)
        );
      }
        setListArray(
          list.map((item) => {
            if (item.name === "Upcoming") {
              return {
                ...item,
                ...(item.count = data.data.data.appointments_count.upcoming),
              };
            }
            if (item.name === "Completed") {
              return {
                ...item,
                ...(item.count = data.data.data.appointments_count.completed),
              };
            }

            if (item.name === "Cancelled") {
              return {
                ...item,
                ...(item.count = data.data.data.appointments_count.cancelled),
              };
            }

            if (item.name === "No Shows") {
              return {
                ...item,
                ...(item.count = data.data.data.appointments_count.noshow),
              };
            }
            if (item.name === "Restriced") {
              return {
                ...item,
                ...(item.count = data.data.data.appointments_count.restrict),
              };
            }
            if (item.name === "Ended Early") {
              return {
                ...item,
                ...(item.count = data.data.data.appointments_count.endearly),
              };
            }
            if (item.name === "Ongoing") {
              return {
                ...item,
                ...(item.count = data.data.data.appointments_count.ongoing),
              };
            }
          })
        );
      })
      .catch((err) => {
        if (err && err.canceled) {
          console.log("⛔ Skipping because request was cancelled");
          return; // **important**
        }else{
          setIsSearching(false);
        }
      });
  };
  const getNoShowsAppointments = (data, activeTab) => {
    //dispatch(setLoading(true));
    let body = {
      ...data,
      screen_name:
        searchValue !== undefined
          ? searchValue.screen_name !== undefined
            ? searchValue.screen_name
            : ""
          : "",
      session_type:
        searchValue !== undefined
          ? searchValue.session_type !== undefined
            ? searchValue.session_type
            : ""
          : "",
      session_id:
        searchValue !== undefined
          ? searchValueFilter.session_id !== undefined
            ? searchValueFilter.session_id
            : ""
          : "",
      // session_type:
      //   searchValue !== undefined
      //     ? searchValue.session_type !== undefined
      //       ? searchValue.session_type
      //       : ""
      //     : "",
      name:
        searchValue !== undefined
          ? searchValue.name !== undefined
            ? searchValue.name
            : ""
          : "",
      medium_email:
        searchValue !== undefined
          ? searchValue.medium_email !== undefined
            ? searchValue.medium_email
            : ""
          : "",
      client_email:
        searchValue !== undefined
          ? searchValue.client_email !== undefined
            ? searchValue.client_email
            : ""
          : "",
      meeting_id:
        searchValue !== undefined
          ? searchValue.meeting_id !== undefined
            ? searchValue.meeting_id
            : ""
          : "",
      created_at:
        searchValue !== undefined && searchValue.created_at !== undefined
          ? searchValue.created_at
          : "",
      session_date: searchValue !== undefined && searchValue.session_date !== undefined ? searchValue.session_date : '',
      oprater: filterOprater !== undefined ? filterOprater : "",
      country: searchValue !== undefined && searchValue.country !== undefined ? searchValue.country : ""
    }
    if(activeTab != tabTrigger){

      body = data;
    }
     const filterKeys = [
  "session_type",
  "medium_name",
   "screen_name",
  "orderBy",
  "name",
  "medium_email",
  "client_email",
  "meeting_id",
  "order",
  "created_at",
  "session_date",
  "country",
  "session_id",
    "loadAll"
];

// Check if ANY filter has value
const hasAnyFilter = filterKeys.some(key =>
  body[key] && body[key].toString().trim() !== ""
);
   if (hasAnyFilter == true || loadAll == true) {
    setIsSearching(true);
    body = {...data, is_count: false};
   } else {
    setIsSearching(false);
    body = {...data, is_count: true};
   }
    getAllNoShowsAppointments(body, activeTab).then((data) => {
      dispatch(setLoading(false));
      if(data.data.data){
           setIsSearching(false);
        }
         if (hasAnyFilter == true || loadAll == true) {
      setShowAppointments(
        data.data.data.info.map((data) => {
          return { ...data, statusValue: "", nostatusValue: "" };
        })
      );
      dispatch(
        setAllUpcomingCount(
          JSON.parse(
            JSON.stringify(data.data.data.appointments_count.upcoming)
          )
        )
        );
        dispatch(
          setAllCompletedCount(
            JSON.parse(
              JSON.stringify(data.data.data.appointments_count.completed)
            )
          )
        );
        dispatch(
          setAllCancelledCount(data.data.data.appointments_count.cancelled)
        );
        dispatch(setAllNoShowCount(data.data.data.appointments_count.noshow));
        dispatch(setAllOngoingCount(data.data.data.appointments_count.ongoing));
        dispatch(
          setAllRestrictedCount(data.data.data.appointments_count.restrict)
        );
        dispatch(
          setEndedEarlyCount(data.data.data.appointments_count.endearly)
        );
      }
        setListArray(
          list.map((item) => {
            if (item.name === "Upcoming") {
              return {
                ...item,
                ...(item.count = data.data.data.appointments_count.upcoming),
              };
            }
            if (item.name === "Completed") {
              return {
                ...item,
                ...(item.count = data.data.data.appointments_count.completed),
              };
            }

            if (item.name === "Cancelled") {
              return {
                ...item,
                ...(item.count = data.data.data.appointments_count.cancelled),
              };
            }

            if (item.name === "No Shows") {
              return {
                ...item,
                ...(item.count = data.data.data.appointments_count.noshow),
              };
            }
            if (item.name === "Restriced") {
              return {
                ...item,
                ...(item.count = data.data.data.appointments_count.restrict),
              };
            }
            if (item.name === "Ended Early") {
              return {
                ...item,
                ...(item.count = data.data.data.appointments_count.endearly),
              };
            }
            if (item.name === "Ongoing") {
              return {
                ...item,
                ...(item.count = data.data.data.appointments_count.ongoing),
              };
            }
          })
        );
      })
      .catch((err) => {
        if (err && err.canceled) {
          console.log("⛔ Skipping because request was cancelled");
          return; // **important**
        }else{
          setIsSearching(false);
        }
      });
  };
  const getRestrictedAppointments = (data, activeTab) => {
    //dispatch(setLoading(true));
    let body = {
      ...data,
      screen_name:
        searchValue !== undefined
          ? searchValue.screen_name !== undefined
            ? searchValue.screen_name
            : ""
          : "",
      session_type:
        searchValue !== undefined
          ? searchValue.session_type !== undefined
            ? searchValue.session_type
            : ""
          : "",
      session_id:
        searchValue !== undefined
          ? searchValueFilter.session_id !== undefined
            ? searchValueFilter.session_id
            : ""
          : "",
      // session_type:
      //   searchValue !== undefined
      //     ? searchValue.session_type !== undefined
      //       ? searchValue.session_type
      //       : ""
      //     : "",
      name:
        searchValue !== undefined
          ? searchValue.name !== undefined
            ? searchValue.name
            : ""
          : "",
      medium_email:
        searchValue !== undefined
          ? searchValue.medium_email !== undefined
            ? searchValue.medium_email
            : ""
          : "",
      client_email:
        searchValue !== undefined
          ? searchValue.client_email !== undefined
            ? searchValue.client_email
            : ""
          : "",
      meeting_id:
        searchValue !== undefined
          ? searchValue.meeting_id !== undefined
            ? searchValue.meeting_id
            : ""
          : "",
      created_at:
        searchValue !== undefined && searchValue.created_at !== undefined
          ? searchValue.created_at
          : "",
      session_date: searchValue !== undefined && searchValue.session_date !== undefined ? searchValue.session_date : '',
      oprater: filterOprater !== undefined ? filterOprater : "",
      country: searchValue !== undefined && searchValue.country !== undefined ? searchValue.country : ""
    }
    if(activeTab != tabTrigger){

      body = data;
    }
        const filterKeys = [
  "session_type",
  "medium_name",
   "screen_name",
  "orderBy",
  "name",
  "medium_email",
  "client_email",
  "meeting_id",
  "order",
  "created_at",
  "session_date",
  "country",
  "session_id",
    "loadAll"
];

// Check if ANY filter has value
const hasAnyFilter = filterKeys.some(key =>
  body[key] && body[key].toString().trim() !== ""
);
   if (hasAnyFilter == true || loadAll == true) {
    setIsSearching(true);
    body = {...data, is_count: false};
   } else {
    setIsSearching(false);
    body = {...data, is_count: true};
   }
    getAllRestrictedAppointments(body, activeTab).then((data) => {
      if(data.data.data){
           setIsSearching(false);
        }
        if (hasAnyFilter == true || loadAll == true) {
      setRestrictedAppontmets(
        data.data.data.info.map((data) => {
          return { ...data, statusValue: "", nostatusValue: "" };
        })
      );
      dispatch(
        setAllUpcomingCount(
          JSON.parse(
            JSON.stringify(data.data.data.appointments_count.upcoming)
          )
        )
        );
        dispatch(
          setAllCompletedCount(
            JSON.parse(
              JSON.stringify(data.data.data.appointments_count.completed)
            )
          )
        );
        dispatch(
          setAllCancelledCount(data.data.data.appointments_count.cancelled)
        );
        dispatch(setAllNoShowCount(data.data.data.appointments_count.noshow));
        dispatch(setAllOngoingCount(data.data.data.appointments_count.ongoing));
        dispatch(
          setAllRestrictedCount(data.data.data.appointments_count.restrict)
        );
        dispatch(
          setEndedEarlyCount(data.data.data.appointments_count.endearly)
        );
      }
        setListArray(
          list.map((item) => {
            if (item.name === "Upcoming") {
              return {
                ...item,
                ...(item.count = data.data.data.appointments_count.upcoming),
              };
            }
            if (item.name === "Completed") {
              return {
                ...item,
                ...(item.count = data.data.data.appointments_count.completed),
              };
            }

            if (item.name === "Cancelled") {
              return {
                ...item,
                ...(item.count = data.data.data.appointments_count.cancelled),
              };
            }

            if (item.name === "No Shows") {
              return {
                ...item,
                ...(item.count = data.data.data.appointments_count.noshow),
              };
            }
            if (item.name === "Restriced") {
              return {
                ...item,
                ...(item.count = data.data.data.appointments_count.restrict),
              };
            }
            if (item.name === "Ended Early") {
              return {
                ...item,
                ...(item.count = data.data.data.appointments_count.endearly),
              };
            }
            if (item.name === "Ongoing") {
              return {
                ...item,
                ...(item.count = data.data.data.appointments_count.ongoing),
              };
            }
          })
        );
        dispatch(setLoading(false));
      })
      .catch((err) => {
        if (err && err.canceled) {
          console.log("⛔ Skipping because request was cancelled");
          return; // **important**
        }else{
          setIsSearching(false);
        }
      });
  };

  const getEndedEarlyAppointments = (data, activeTab) => {
   // dispatch(setLoading(true));
    let body = {
      ...data,
      screen_name:
        searchValue !== undefined
          ? searchValue.screen_name !== undefined
            ? searchValue.screen_name
            : ""
          : "",
      session_type:
        searchValue !== undefined
          ? searchValue.session_type !== undefined
            ? searchValue.session_type
            : ""
          : "",
      session_id:
        searchValue !== undefined
          ? searchValueFilter.session_id !== undefined
            ? searchValueFilter.session_id
            : ""
          : "",
      // session_type:
      //   searchValue !== undefined
      //     ? searchValue.session_type !== undefined
      //       ? searchValue.session_type
      //       : ""
      //     : "",
      name:
        searchValue !== undefined
          ? searchValue.name !== undefined
            ? searchValue.name
            : ""
          : "",
      medium_email:
        searchValue !== undefined
          ? searchValue.medium_email !== undefined
            ? searchValue.medium_email
            : ""
          : "",
      client_email:
        searchValue !== undefined
          ? searchValue.client_email !== undefined
            ? searchValue.client_email
            : ""
          : "",
      meeting_id:
        searchValue !== undefined
          ? searchValue.meeting_id !== undefined
            ? searchValue.meeting_id
            : ""
          : "",
      created_at:
        searchValue !== undefined && searchValue.created_at !== undefined
          ? searchValue.created_at
          : "",
      session_date: searchValue !== undefined && searchValue.session_date !== undefined ? searchValue.session_date : '',
      oprater: filterOprater !== undefined ? filterOprater : "",
      country: searchValue !== undefined && searchValue.country !== undefined ? searchValue.country : ""
    }
    if(activeTab != tabTrigger){

      body = data;
    }
     const filterKeys = [
  "session_type",
  "medium_name",
   "screen_name",
  "orderBy",
  "name",
  "medium_email",
  "client_email",
  "meeting_id",
  "order",
  "created_at",
  "session_date",
  "country",
  "session_id",
    "loadAll"

];

// Check if ANY filter has value
const hasAnyFilter = filterKeys.some(key =>
  body[key] && body[key].toString().trim() !== ""
);
   if (hasAnyFilter == true || loadAll == true) {
    setIsSearching(true);
    body = {...data, is_count: false};
   } else {
    setIsSearching(false);
    body = {...data, is_count: true};
   }
    getAllEndedEarlyAppointments(body, activeTab).then((data) => {
      if(data.data.data){
           setIsSearching(false);
        }
         if (hasAnyFilter == true || loadAll == true) {
      setEndedEarlyAppontmets(
        data.data.data.info.map((data) => {
          return { ...data, statusValue: "", nostatusValue: "" };
        })
      );
      dispatch(
        setAllUpcomingCount(
          JSON.parse(
            JSON.stringify(data.data.data.appointments_count.upcoming)
          )
        )
        );
        dispatch(
          setAllCompletedCount(
            JSON.parse(
              JSON.stringify(data.data.data.appointments_count.completed)
            )
          )
        );
        dispatch(
          setAllCancelledCount(data.data.data.appointments_count.cancelled)
        );
        dispatch(setAllNoShowCount(data.data.data.appointments_count.noshow));
        dispatch(setAllOngoingCount(data.data.data.appointments_count.ongoing));
        dispatch(
          setAllRestrictedCount(data.data.data.appointments_count.restrict)
        );
        dispatch(
          setEndedEarlyCount(data.data.data.appointments_count.endearly)
        );
      }
        setListArray(
          list.map((item) => {
            if (item.name === "Upcoming") {
              return {
                ...item,
                ...(item.count = data.data.data.appointments_count.upcoming),
              };
            }
            if (item.name === "Completed") {
              return {
                ...item,
                ...(item.count = data.data.data.appointments_count.completed),
              };
            }

            if (item.name === "Cancelled") {
              return {
                ...item,
                ...(item.count = data.data.data.appointments_count.cancelled),
              };
            }

          if (item.name === "No Shows") {
            return {
              ...item,
              ...(item.count = data.data.data.appointments_count.noshow),
            };
          }
          if (item.name === "Restriced") {
            return {
              ...item,
              ...(item.count = data.data.data.appointments_count.restrict),
            };
          }
          if (item.name === "Ended Early") {
            return {
              ...item,
              ...(item.count = data.data.data.appointments_count.endearly),
            };
          }
          if (item.name === "Ongoing") {
            return {
              ...item,
              ...(item.count = data.data.data.appointments_count.ongoing),
            };
          }
        })
      );
      dispatch(setLoading(false));
    }).catch((err) => {  if (err && err.canceled) {
          console.log("⛔ Skipping because request was cancelled");
          return; // **important**
        }else{
          setIsSearching(false);
        } })



  }
  
  const getOngoingAppointments = (data, activeTab) => {
   // dispatch(setLoading(true));
    getAllOngoingAppointments(data, activeTab)
      .then((data) => {
        dispatch(setLoading(false));
        setOngoingAppointments(
          data.data.data.info.map((data) => {
            return { ...data, statusValue: "", nostatusValue: "" };
          })
        );
        dispatch(
          setAllUpcomingCount(
            JSON.parse(
              JSON.stringify(data.data.data.appointments_count.upcoming)
            )
          )
        );
        dispatch(
          setAllCompletedCount(
            JSON.parse(
              JSON.stringify(data.data.data.appointments_count.completed)
            )
          )
        );
        dispatch(
          setAllCancelledCount(data.data.data.appointments_count.cancelled)
        );
        dispatch(setAllNoShowCount(data.data.data.appointments_count.noshow));
        dispatch(setAllOngoingCount(data.data.data.appointments_count.ongoing));
        dispatch(
          setAllRestrictedCount(data.data.data.appointments_count.restrict)
        );
        dispatch(
          setEndedEarlyCount(data.data.data.appointments_count.endearly)
        );
        setListArray(
          list.map((item) => {
            if (item.name === "Upcoming") {
              return {
                ...item,
                ...(item.count = data.data.data.appointments_count.upcoming),
              };
            }
            if (item.name === "Completed") {
              return {
                ...item,
                ...(item.count = data.data.data.appointments_count.completed),
              };
            }

            if (item.name === "Cancelled") {
              return {
                ...item,
                ...(item.count = data.data.data.appointments_count.cancelled),
              };
            }

            if (item.name === "No Shows") {
              return {
                ...item,
                ...(item.count = data.data.data.appointments_count.noshow),
              };
            }
            if (item.name === "Restriced") {
              return {
                ...item,
                ...(item.count = data.data.data.appointments_count.restrict),
              };
            }
            if (item.name === "Ended Early") {
              return {
                ...item,
                ...(item.count = data.data.data.appointments_count.endearly),
              };
            }
            if (item.name === "Ongoing") {
              return {
                ...item,
                ...(item.count = data.data.data.appointments_count.ongoing),
              };
            }
          })
        );
      })
      .catch((err) => {
         if (err && err.canceled) {
          console.log("⛔ Skipping because request was cancelled");
          return; // **important**
        }else{
          setIsSearching(false);
        }
      });
  };
  const filterserviceListValue = (list, id) => {
    let info = list.filter((e) => e.value === id);
    return info.length ? info[0].name : "";
  };
  /////
  const getPaginationData = (data, activeTab) => {
    console.log(
      data,
      activeTab,
      "data, activeTab",
      sortingNameOrderBy,
      sortingTtabType
    );
    if (activeTab + 1 === parseInt(sortingTtabType)) {
      Object.assign(data, sortingNameOrderBy);
    }
    let dat = {
      ...data,
      screen_name:
        searchValue !== undefined
          ? searchValue.screen_name !== undefined
            ? searchValue.screen_name
            : ""
          : "",
      session_type:
        searchValue !== undefined
          ? searchValue.session_type !== undefined
            ? searchValue.session_type
            : ""
          : "",
      session_id:
        searchValue !== undefined
          ? searchValueFilter.session_id !== undefined
            ? searchValueFilter.session_id
            : ""
          : "",
      // session_type:
      //   searchValue !== undefined
      //     ? searchValue.session_type !== undefined
      //       ? searchValue.session_type
      //       : ""
      //     : "",
      name:
        searchValue !== undefined
          ? searchValue.name !== undefined
            ? searchValue.name
            : ""
          : "",
      medium_email:
        searchValue !== undefined
          ? searchValue.medium_email !== undefined
            ? searchValue.medium_email
            : ""
          : "",
      client_email:
        searchValue !== undefined
          ? searchValue.client_email !== undefined
            ? searchValue.client_email
            : ""
          : "",
      meeting_id:
        searchValue !== undefined
          ? searchValue.meeting_id !== undefined
            ? searchValue.meeting_id
            : ""
          : "",
      created_at:
        searchValue !== undefined && searchValue.created_at !== undefined
          ? searchValue.created_at
          : "",
    session_date: searchValue !== undefined && searchValue.session_date !== undefined ? searchValue.session_date : '',
      oprater: filterOprater !== undefined ? filterOprater : "",
      country:
        searchValue !== undefined && searchValue.country !== undefined
          ? searchValue.country
          : "",
    };
  
    // getAllAppointmentsList
    // getUpComingAppointments(data,activeTab)
    if (activeTab === 0) {
      getUpComingAppointments(dat, activeTab);
      
    }
    if (activeTab === 1) {
      getCompletedAppointments(dat, activeTab);
    }
    if (activeTab === 2) {
      getCancelledAppointments(dat, activeTab);
    }
    if (activeTab === 3) {
      getNoShowsAppointments(dat, activeTab);
    }
    if (activeTab === 4) {
      getRestrictedAppointments(dat, activeTab);
    }
    if (activeTab === 5) {
      getEndedEarlyAppointments(dat, activeTab);
    }
    if (activeTab === 6) {
      getOngoingAppointments(dat, activeTab);
    }
  };

  const updateTimezones = () => {
    getTimezones()
      .then((data) => {
        dispatch(setTimezoneArray(data.data.data));
      })
      .catch((err) => console.log(err));
  };
  const changeTimeZoneHandler = (e) => {
    let id = e.target.value;
    let body = {
      timezone_id: id,
    };
    setNewTimeZone(body)
      .then((data) => {
        if (data.data.status) {
          const data = {
            page: 1,
            rowsPerPage: 25,
          };
          
          dispatch(setNewTimeZoneData(filterTimeZone(id)));
          getDateAppt()
        }
      })
      .catch(() => { });
  };
  const filterTimeZone = (id) => {
    let zone;
    timezoneData.filter((item) => {
      if (parseInt(id) === parseInt(item.id)) {
        zone = item.front_name;
      }
    });
    return zone;
  };
  useEffect(() => {
    downloadExport(activeTab);
    console.log("data")
    const data = {
      page: 1,
      rowsPerPage: 25,
      screen_name:
        searchValue !== undefined
          ? searchValue.screen_name !== undefined
            ? searchValue.screen_name
            : ""
          : "",
      session_type:
        searchValue !== undefined
          ? searchValue.session_type !== undefined
            ? searchValue.session_type
            : ""
          : "",
      session_id:
        searchValue !== undefined
          ? searchValueFilter.session_id !== undefined
            ? searchValueFilter.session_id
            : ""
          : "",
      // session_type:
      //   searchValue !== undefined
      //     ? searchValue.session_type !== undefined
      //       ? searchValue.session_type
      //       : ""
      //     : "",
      name:
        searchValue !== undefined
          ? searchValue.name !== undefined
            ? searchValue.name
            : ""
          : "",
      medium_email:
        searchValue !== undefined
          ? searchValue.medium_email !== undefined
            ? searchValue.medium_email
            : ""
          : "",
      client_email:
        searchValue !== undefined
          ? searchValue.client_email !== undefined
            ? searchValue.client_email
            : ""
          : "",
      meeting_id:
        searchValue !== undefined
          ? searchValue.meeting_id !== undefined
            ? searchValue.meeting_id
            : ""
          : "",
      created_at:
        searchValue !== undefined && searchValue.created_at !== undefined
          ? searchValue.created_at
          : "",
          session_date: searchValue !== undefined && searchValue.session_date !== undefined ? searchValue.session_date : '',
      oprater: filterOprater !== undefined ? filterOprater : "",
      country:
        searchValue !== undefined && searchValue.country !== undefined
          ? searchValue.country
          : "",
    };
    
console.log(tabTrigger,"status  2 ", activeTab)

 if(activeTab == tabTrigger){

  return;
 }

 setTabTrigger(100);
    if (activeTab === 0) {
      getUpComingAppointments(data, activeTab);
    }
    if (activeTab === 1) {
      getCompletedAppointments(data, activeTab);
    }
    if (activeTab === 2) {
      getCancelledAppointments(data, activeTab);
    }
    if (activeTab === 3) {
      getNoShowsAppointments(data, activeTab);
    }
    if (activeTab === 4) {
      getRestrictedAppointments(data, activeTab);
    }
    if (activeTab === 5) {
      getEndedEarlyAppointments(data, activeTab);
    }
    if (activeTab === 6) {
      getOngoingAppointments(data, activeTab);
    }
    // getAllAppointmentsList(data, activeTab);

    // let resp = {
    //   upcoming: backuupcoming,
    //   completed: backuupcompleted,
    //   cancelled: backuupcancelled,
    //   show: backuupnoshow,
    //   ongoing: backuupnongoing,
    // };
    // dispatch(setAllAppointments(resp));
  }, [activeTab]);
  const getDateAppt = () => {
    downloadExport(activeTab);
    console.log("data")
    const data = {
      page: 1,
      rowsPerPage: 25,
      screen_name:
        searchValue !== undefined
          ? searchValue.screen_name !== undefined
            ? searchValue.screen_name
            : ""
          : "",
      session_type:
        searchValue !== undefined
          ? searchValue.session_type !== undefined
            ? searchValue.session_type
            : ""
          : "",
      session_id:
        searchValue !== undefined
          ? searchValueFilter.session_id !== undefined
            ? searchValueFilter.session_id
            : ""
          : "",
      // session_type:
      //   searchValue !== undefined
      //     ? searchValue.session_type !== undefined
      //       ? searchValue.session_type
      //       : ""
      //     : "",
      name:
        searchValue !== undefined
          ? searchValue.name !== undefined
            ? searchValue.name
            : ""
          : "",
      medium_email:
        searchValue !== undefined
          ? searchValue.medium_email !== undefined
            ? searchValue.medium_email
            : ""
          : "",
      client_email:
        searchValue !== undefined
          ? searchValue.client_email !== undefined
            ? searchValue.client_email
            : ""
          : "",
      meeting_id:
        searchValue !== undefined
          ? searchValue.meeting_id !== undefined
            ? searchValue.meeting_id
            : ""
          : "",
      created_at:
        searchValue !== undefined && searchValue.created_at !== undefined
          ? searchValue.created_at
          : "",
          session_date: searchValue !== undefined && searchValue.session_date !== undefined ? searchValue.session_date : '',
      oprater: filterOprater !== undefined ? filterOprater : "",
      country:
        searchValue !== undefined && searchValue.country !== undefined
          ? searchValue.country
          : "",
    };
    
console.log(tabTrigger,"status  2 ", activeTab)

 if(activeTab == tabTrigger){

  return;
 }

 setTabTrigger(100);
    if (activeTab === 0) {
      getUpComingAppointments(data, activeTab);
    }
    if (activeTab === 1) {
      getCompletedAppointments(data, activeTab);
    }
    if (activeTab === 2) {
      getCancelledAppointments(data, activeTab);
    }
    if (activeTab === 3) {
      getNoShowsAppointments(data, activeTab);
    }
    if (activeTab === 4) {
      getRestrictedAppointments(data, activeTab);
    }
    if (activeTab === 5) {
      getEndedEarlyAppointments(data, activeTab);
    }
    if (activeTab === 6) {
      getOngoingAppointments(data, activeTab);
    }
  }

  // useEffect(() => {
  //   setUpcomingAppointments(
  //     allUpcomingAppointments.map((data) => {
  //       return { ...data, statusValue: "", nostatusValue: "" };
  //     })
  //   );
  //   setCompletedAppointments(
  //     allCompletedAppointments.map((data) => {
  //       return { ...data, statusValue: "", nostatusValue: "" };
  //     })
  //   );
  //   setCanceledAppointments(allCancelledAppointments);
  //   setShowAppointments(allNoShowsAppointments);
  //   setOngoingAppointments(allOngoingAppointments);
  //   setListArray(
  //     list.map((item) => {
  //       if (item.name === "Upcoming") {
  //         return {
  //           ...item,
  //           ...(item.count = allUpcomingCount),
  //         };
  //       }
  //       if (item.name === "Completed") {
  //         return {
  //           ...item,
  //           ...(item.count = allCompletedCount),
  //         };
  //       }

  //       if (item.name === "Cancelled") {
  //         return {
  //           ...item,
  //           ...(item.count = allCancelledCount),
  //         };
  //       }

  //       if (item.name === "No Shows") {
  //         return {
  //           ...item,
  //           ...(item.count = allNoShowCount),
  //         };
  //       }
  //       if (item.name === "Ongoing") {
  //         return {
  //           ...item,
  //           ...(item.count = allOngoingCount),
  //         };
  //       }
  //     })
  //   );
  // }, [
  //   allCompletedAppointments,
  //   allUpcomingAppointments,
  //   allCancelledAppointments,
  //   allNoShowsAppointments,
  //   allOngoingAppointments,
  // ]);
  const getAllAppointmentsList = (paginationdata, activeTab, info) => {
    if (info === "refresh") {
      dispatch(setLoading(true));
    }
    let dat = {
      ...paginationdata,
      screen_name:
        searchValue !== undefined
          ? searchValue.screen_name !== undefined
            ? searchValue.screen_name
            : ""
          : "",
      session_type:
        serviceFilterValue !== ""
          ? filterserviceListValue(
            serviceTypeList,
            parseInt(serviceFilterValue)
          )
          : searchValue !== undefined && searchValue.session_type !== undefined
            ? searchValue.session_type
            : "",
      // session_type:
      //   searchValue !== undefined
      //     ? searchValue.session_type !== undefined
      //       ? searchValue.session_type
      //       : ""
      //     : "",
      name:
        searchValue !== undefined
          ? searchValue.name !== undefined
            ? searchValue.name
            : ""
          : "",
      medium_email:
        searchValue !== undefined
          ? searchValue.medium_email !== undefined
            ? searchValue.medium_email
            : ""
          : "",
      client_email:
        searchValue !== undefined
          ? searchValue.client_email !== undefined
            ? searchValue.client_email
            : ""
          : "",
      meeting_id:
        searchValue !== undefined
          ? searchValue.meeting_id !== undefined
            ? searchValue.meeting_id
            : ""
          : "",
      created_at:
        searchValue !== undefined && searchValue.created_at !== undefined
          ? searchValue.created_at
          : "",
          session_date: searchValue !== undefined && searchValue.session_date !== undefined ? searchValue.session_date : '',
    };

    let appointmentType = "";
    if (activeTab === 0) {
      appointmentType = "upcoming";
    }
    if (activeTab === 1) {
      appointmentType = "completed";
    }
    if (activeTab === 2) {
      appointmentType = "cancelled";
    }
    if (activeTab === 3) {
      appointmentType = "show";
    }
    if (activeTab === 4) {
      appointmentType = "ongoing";
    }
    getAllAppointments(dat, appointmentType)
      .then((data) => {
        dispatch(setLoading(false));
        if (data.data.status) {
          //

          //
          // dispatch();
          dispatch(setAllAppointments(data.data.data));
          setbackupUpcoming(
            JSON.parse(JSON.stringify(data.data.data.upcoming))
          );
          setbackupCompleted(
            JSON.parse(JSON.stringify(data.data.data.completed))
          );
          setbackupCancelled(
            JSON.parse(JSON.stringify(data.data.data.cancelled))
          );
          setbackupUpNoShow(JSON.parse(JSON.stringify(data.data.data.show)));
          setbackupOngoing(JSON.parse(JSON.stringify(data.data.data.ongoing)));

          dispatch(
            setAllUpcomingCount(data.data.data.upcoming_pagination.total)
          );

          dispatch(
            setAllUpcomingCount(
              JSON.parse(
                JSON.stringify(data.data.data.upcoming_pagination.total)
              )
            )
          );

          dispatch(
            setAllCompletedCount(
              JSON.parse(
                JSON.stringify(data.data.data.completed_pagination.total)
              )
            )
          );
          dispatch(
            setAllCancelledCount(
              JSON.parse(
                JSON.stringify(data.data.data.cancelled_pagination.total)
              )
            )
          );
          dispatch(
            setAllNoShowCount(
              JSON.parse(JSON.stringify(data.data.data.show_pagination.total))
            )
          );
          dispatch(
            setAllOngoingCount(
              JSON.parse(
                JSON.stringify(data.data.data.ongoing_pagination.total)
              )
            )
          );
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const launcApi = () => {
    const data = {
      page: 1,
      rowsPerPage: 25,
      screen_name:
        searchValue !== undefined
          ? searchValue.screen_name !== undefined
            ? searchValue.screen_name
            : ""
          : "",
      session_type:
        serviceFilterValue !== ""
          ? filterserviceListValue(
            serviceTypeList,
            parseInt(serviceFilterValue)
          )
          : "",
      // session_type:
      //   searchValue !== undefined
      //     ? searchValue.session_type !== undefined
      //       ? searchValue.session_type
      //       : ""
      //     : "",
      name:
        searchValue !== undefined
          ? searchValue.name !== undefined
            ? searchValue.name
            : ""
          : "",
      medium_email:
        searchValue !== undefined
          ? searchValue.medium_email !== undefined
            ? searchValue.medium_email
            : ""
          : "",
      client_email:
        searchValue !== undefined
          ? searchValue.client_email !== undefined
            ? searchValue.client_email
            : ""
          : "",
      meeting_id:
        searchValue !== undefined
          ? searchValue.meeting_id !== undefined
            ? searchValue.meeting_id
            : ""
          : "",
      created_at:
        searchValue !== undefined && searchValue.created_at !== undefined
          ? searchValue.created_at
          : "",
          session_date: searchValue !== undefined && searchValue.session_date !== undefined ? searchValue.session_date : '',
    };
    setIsSearching(true);
    getUpComingAppointments(data, activeTab);
    // if (
    //   !allUpcomingAppointments.length > 0 ||
    //   !allCompletedAppointments.length > 0 ||
    //   !allCancelledAppointments.length > 0 ||
    //   !allNoShowsAppointments.length > 0 ||
    //   !allOngoingAppointments.length > 0
    // ) {
    // getAllAppointmentsList(data, activeTab);
    // }
  };

  const changeStatus = (userId, status, appointmentId, selectedReason =null) => {
    let body = {};
    if(selectedReason && selectedReason!="" && selectedReason != null){
        body = {
        userId: userId,
        status: status,
        appointmentId: appointmentId,
        reason : selectedReason
      };
    }else{
       body = {
        userId: userId,
        status: status,
        appointmentId: appointmentId,

      };
    }
    
    changeAppointmentStatus(body)
      .then((data) => {
        if (data.data.status) {
          toast.success("Status updated succesfully", {
            position: "top-center",
          });
          window.loadModal2("#ConfirmCancelAdmin", "hide");

              const data1 = {
      page: 1,
      rowsPerPage: 25,
      screen_name:
        searchValue !== undefined
          ? searchValue.screen_name !== undefined
            ? searchValue.screen_name
            : ""
          : "",
      session_type:
        searchValue !== undefined
          ? searchValue.session_type !== undefined
            ? searchValue.session_type
            : ""
          : "",
      session_id:
        searchValue !== undefined
          ? searchValueFilter.session_id !== undefined
            ? searchValueFilter.session_id
            : ""
          : "",
      // session_type:
      //   searchValue !== undefined
      //     ? searchValue.session_type !== undefined
      //       ? searchValue.session_type
      //       : ""
      //     : "",
      name:
        searchValue !== undefined
          ? searchValue.name !== undefined
            ? searchValue.name
            : ""
          : "",
      medium_email:
        searchValue !== undefined
          ? searchValue.medium_email !== undefined
            ? searchValue.medium_email
            : ""
          : "",
      client_email:
        searchValue !== undefined
          ? searchValue.client_email !== undefined
            ? searchValue.client_email
            : ""
          : "",
      meeting_id:
        searchValue !== undefined
          ? searchValue.meeting_id !== undefined
            ? searchValue.meeting_id
            : ""
          : "",
      created_at:
        searchValue !== undefined && searchValue.created_at !== undefined
          ? searchValue.created_at
          : "",
        session_date: searchValue !== undefined && searchValue.session_date !== undefined ? searchValue.session_date : '',
      oprater: filterOprater !== undefined ? filterOprater : "",
      country:
        searchValue !== undefined && searchValue.country !== undefined
          ? searchValue.country
          : "",
    };
          if (activeTab === 0) {
            // if(status ==3){
            //   setUpcomingAppointments((prev) => prev.filter((item) => item.id !== appointmentId));
            //   dispatch(
            //           setAllUpcomingCount(
            //             allUpcomingCount - 1
            //             )
            //         )
            //   transferCount( "Upcoming", "Cancelled");
            // } else if(status ==2){
            //   setUpcomingAppointments((prev) => prev.filter((item) => item.id !== appointmentId));
            //     dispatch(
            //             setAllUpcomingCount(
            //               allUpcomingCount - 1
            //               )
            //           )
            //   transferCount( "Upcoming","No Shows");
            // }else{
             
               getUpComingAppointments(data1, activeTab);
            // }
           
           // getUpComingAppointments(data, activeTab);
          } else if (activeTab === 1) {
            // if(status ==2){
            // setCompletedAppointments((prev) => prev.filter((item) => item.id !== appointmentId));
            //   dispatch(
            //           setAllCompletedCount(
            //             allCompletedCount - 1
            //             )
            //         )
            //   transferCount( "Completed", "No Shows");
            //       }else{
                    getCompletedAppointments(data1, activeTab);
                  // }
           // getCompletedAppointments(data, activeTab);
          }
          // getAllAppointmentsList(data, activeTab);
          emptyAllSelectBox();
        } else {
          toast.error("Something went wrong", { position: "top-center" });
        }
      })
      .catch(() => { });
  };
  const changeHandler = (e, status, appointmentId, selectedReason=null) => {
    let value = e.target.value;
    changeStatus(value, status, appointmentId, selectedReason);
  };
  const filterListAppointments = (constants, oprateVal) => {
    const {
      session_type = serviceFilterValue !== ""
        ? filterserviceListValue(serviceTypeList, parseInt(serviceFilterValue))
        : "",
      screen_name,
      orderBy = "asc",
      name,
      medium_email,
      client_email,
      meeting_id,
      country,
    } = constants;
    let body = {
      session_type,
      screen_name,
      orderBy,
      name,
      medium_email,
      client_email,
      country,
      meeting_id,
    };
    filterAllAppointments(body)
      .then((data) => {
        if (data.data.status) {
          dispatch(
            setAllUpcomingCount(data.data.data.upcoming_pagination.total)
          );

          dispatch(
            setAllCompletedCount(data.data.data.completed_pagination.total)
          );
          dispatch(
            setAllCancelledCount(data.data.data.cancelled_pagination.total)
          );
          dispatch(setAllNoShowCount(data.data.data.show_pagination.total));
          dispatch(setAllOngoingCount(data.data.data.ongoing_pagination.total));
          dispatch(setAllAppointments(data.data.data));
        }
      })
      .catch(() => { });
  };

  const filterListUpcomingAppointments = (
    constants,
    from,
    value,
    oprateVal
  ) => {
    console.log(searchValue, "", filterValues, "", "");
    console.log(constants, "constat", oprateVal , "oprateVal");
    console.log(searchValueFilter, "serviceFilterValue", from, "", value);

setIsSearching(true);
    if (constants !== undefined && constants.session_type !== undefined) {
      setServiceFilterValue("");
      setSearchValuesFilter("");
    }
    const {
      session_type,
      screen_name,
      orderBy = "desc",
      order,
      name,
      medium_email,
      client_email,
      meeting_id,
      created_at,
      session_date,
      country,
    } = constants;
    let namdefault = "";
    let session_typesefault = "";
    let screen_namedefault = "";
    let medium_emaildefault = "";
    let client_emaildefault = "";
    let meeting_iddefault = "";
    let created_atdefault = "";
    let session_datedefault = "";
    let countrydefault = "";
    let session_iddefault = "";
    if (
      (constants !== undefined && constants.orderBy) ||
      (from !== undefined && from == "filter")
    ) {
      namdefault =
        constants.name == undefined
          ? searchValue !== undefined && searchValue.name !== undefined
            ? searchValue.name
            : ""
          : constants.name;
      session_typesefault =
        constants.session_type == undefined
          ? searchValue !== undefined && searchValue.session_type !== undefined
            ? searchValue.session_type
            : ""
          : constants.session_type;
      screen_namedefault =
        constants.screen_name == undefined
          ? searchValue !== undefined && searchValue.screen_name !== undefined
            ? searchValue.screen_name
            : ""
          : constants.screen_name;
      medium_emaildefault =
        constants.medium_email == undefined
          ? searchValue !== undefined && searchValue.medium_email !== undefined
            ? searchValue.medium_email
            : ""
          : constants.medium_email;
      client_emaildefault =
        constants.client_email == undefined
          ? searchValue !== undefined && searchValue.client_email !== undefined
            ? searchValue.client_email
            : ""
          : constants.client_email;
      meeting_iddefault =
        constants.meeting_id == undefined
          ? searchValue !== undefined && searchValue.meeting_id !== undefined
            ? searchValue.meeting_id
            : ""
          : constants.meeting_id;
      created_atdefault =
        constants.created_at == undefined
          ? searchValue !== undefined && searchValue.created_at !== undefined
            ? searchValue.created_at
            : ""
          : constants.created_at;
          session_datedefault = constants.session_date == undefined
          ? searchValue !== undefined && searchValue.session_date !== undefined
            ? searchValue.session_date
            : ""
          : constants.session_date;
      countrydefault =
        constants.country == undefined
          ? searchValue !== undefined && searchValue.country !== undefined
            ? searchValue.country
            : ""
          : constants.country;
    }
    if (from !== undefined && from == "filter") {
      session_typesefault = "";
    }
    if (constants !== undefined && constants.session_type) {
      session_iddefault = "";
    } else {
      session_iddefault =
        constants.session_id == undefined
          ? searchValueFilter !== undefined &&
            searchValueFilter.session_id !== undefined
            ? searchValueFilter.session_id
            : ""
          : constants.session_id;
    }
    let body = {
      orderBy,
      order,
      screen_name:
        constants !== undefined
          ? constants.screen_name !== undefined
            ? constants.screen_name
            : screen_namedefault
          : "",

      session_type:
        constants !== undefined
          ? constants.session_type !== undefined
            ? constants.session_type
            : session_typesefault
          : "",
      session_id:
        constants !== undefined
          ? constants.session_id !== undefined
            ? constants.session_id
            : session_iddefault
          : "",
      // session_type:
      //   constants !== undefined
      //     ? constants.session_type !== undefined
      //       ? constants.session_type
      //       : ""
      //     : "",
      name:
        constants !== undefined
          ? constants.name !== undefined
            ? constants.name
            : namdefault
          : "",
      medium_email:
        constants !== undefined
          ? constants.medium_email !== undefined
            ? constants.medium_email
            : medium_emaildefault
          : "",
      client_email:
        constants !== undefined
          ? constants.client_email !== undefined
            ? constants.client_email
            : client_emaildefault
          : "",
      meeting_id:
        constants !== undefined
          ? constants.meeting_id !== undefined
            ? constants.meeting_id
            : meeting_iddefault
          : "",
      created_at:
        constants !== undefined
          ? constants.created_at !== undefined
            ? constants.created_at
            : created_atdefault
          : "",
          session_date:  constants !== undefined
          ? constants.session_date !== undefined
            ? constants.session_date
            : session_datedefault
          : "",
      oprater: oprateVal !== undefined ? oprateVal : filterOprater,
      country:
        constants !== undefined
          ? constants.country !== undefined
            ? constants.country
            : countrydefault
          : "",
    };
     setIsSearching(true);
    filterAllUpcomingAppointments(body)
      .then((data) => {
        if (data.data.status) {
          setIsSearching(false);
           setIsSearching(false);
          dispatch(setUpcomingAppointmentsPage(upcomingAppointmentsPage + 1));
          dispatch(setUpcomingAppointmentsrowsPerPage(globalRowsPerPage));
          dispatch(setLoading(false));
          //
          dispatch(
            setAllUpcomingCount(
              JSON.parse(
                JSON.stringify(data.data.data.appointments_count.upcoming)
              )
            )
          );

          dispatch(
            setAllCompletedCount(
              JSON.parse(
                JSON.stringify(data.data.data.appointments_count.completed)
              )
            )
          );
          dispatch(
            setAllCancelledCount(data.data.data.appointments_count.cancelled)
          );
          dispatch(setAllNoShowCount(data.data.data.appointments_count.noshow));
          dispatch(
            setAllOngoingCount(data.data.data.appointments_count.ongoing)
          );

          //
          setUpcomingAppointments(
            data.data.data.info.map((data) => {
              return {
                ...data,
                statusValue: "",
                nostatusValue: "",
                noOfAttendees: checkStatus0Values(data),
                noOfWorkers: checkWorkersValues(data),
              };
            })
          );

          dispatch(
            setAllRestrictedCount(data.data.data.appointments_count.restrict)
          );
          dispatch(
            setEndedEarlyCount(data.data.data.appointments_count.endearly)
          );
          setListArray(
            list.map((item) => {
              if (item.name === "Upcoming") {
                return {
                  ...item,
                  ...(item.count = data.data.data.appointments_count.upcoming),
                };
              }
              if (item.name === "Completed") {
                return {
                  ...item,
                  ...(item.count = data.data.data.appointments_count.completed),
                };
              }

              if (item.name === "Cancelled") {
                return {
                  ...item,
                  ...(item.count = data.data.data.appointments_count.cancelled),
                };
              }

              if (item.name === "No Shows") {
                return {
                  ...item,
                  ...(item.count = data.data.data.appointments_count.noshow),
                };
              }
              if (item.name === "Restriced") {
                return {
                  ...item,
                  ...(item.count = data.data.data.appointments_count.restrict),
                };
              }
              if (item.name === "Ended Early") {
                return {
                  ...item,
                  ...(item.count = data.data.data.appointments_count.endearly),
                };
              }
              if (item.name === "Ongoing") {
                return {
                  ...item,
                  ...(item.count = data.data.data.appointments_count.ongoing),
                };
              }
            })
          );
        }
      })
      .catch(() => { setIsSearching(false);});
  };

  const filterListCompletedAppointments = (constants, from, value ,oprateVal) => {
    if (from !== 'filter'  && constants.session_type !== undefined) {
      setServiceFilterValue('');
      setSearchValuesFilter('');
    }
    setIsSearching(true);
    const {
      session_type,
      screen_name,
      orderBy = "desc",
      order,
      name,
      medium_email,
      client_email,
      meeting_id,
    } = constants;
    let namdefault = "";
    let session_typesefault = "";
    let screen_namedefault = "";
    let medium_emaildefault = "";
    let client_emaildefault = "";
    let meeting_iddefault = "";
    let created_atdefault = "";
    let session_datedefault = "";
    let countrydefault = "";
    let session_iddefault = "";
    if (
      (constants !== undefined && constants.orderBy) ||
      (from !== undefined && from == "filter")
    ) {
      screen_namedefault =
        constants.screen_name == undefined
          ? searchValue !== undefined && searchValue.screen_name !== undefined
            ? searchValue.screen_name
            : ""
          : constants.screen_name;
      namdefault =
        constants.name == undefined
          ? searchValue !== undefined && searchValue.name !== undefined
            ? searchValue.name
            : ""
          : constants.name;
      session_typesefault =
        constants.session_type == undefined
          ? searchValue !== undefined && searchValue.session_type !== undefined
            ? searchValue.session_type
            : ""
          : constants.session_type;
      medium_emaildefault =
        constants.medium_email == undefined
          ? searchValue !== undefined && searchValue.medium_email !== undefined
            ? searchValue.medium_email
            : ""
          : constants.medium_email;
      client_emaildefault =
        constants.client_email == undefined
          ? searchValue !== undefined && searchValue.client_email !== undefined
            ? searchValue.client_email
            : ""
          : constants.client_email;
      meeting_iddefault =
        constants.meeting_id == undefined
          ? searchValue !== undefined && searchValue.meeting_id !== undefined
            ? searchValue.meeting_id
            : ""
          : constants.meeting_id;
      created_atdefault =
        constants.created_at == undefined
          ? searchValue !== undefined && searchValue.created_at !== undefined
            ? searchValue.created_at
            : ""
          : constants.created_at;
          session_datedefault =
           constants.session_date == undefined
          ? searchValue !== undefined && searchValue.session_date !== undefined
            ? searchValue.session_date
            : ""
          : constants.session_date;
      countrydefault =
        constants.country == undefined
          ? searchValue !== undefined && searchValue.country !== undefined
            ? searchValue.country
            : ""
          : constants.country;
    }
    if (from !== undefined && from == "filter") {
      session_typesefault = "";
    }
    if (constants !== undefined && constants.session_type) {
      session_iddefault = "";
    } else {
      session_iddefault =
        constants.session_id == undefined
          ? searchValueFilter !== undefined &&
            searchValueFilter.session_id !== undefined
            ? searchValueFilter.session_id
            : ""
          : constants.session_id;
    }
    let body = {
      orderBy,
      order,
      screen_name:
        constants !== undefined
          ? constants.screen_name !== undefined
            ? constants.screen_name
            : screen_namedefault
          : "",
      session_type:
        constants !== undefined
          ? constants.session_type !== undefined
            ? constants.session_type
            : session_typesefault
          : "",
      session_id:
        constants !== undefined
          ? constants.session_id !== undefined
            ? constants.session_id
            : session_iddefault
          : "",
      // session_type:
      //   constants !== undefined
      //     ? constants.session_type !== undefined
      //       ? constants.session_type
      //       : ""
      //     : "",
      name:
        constants !== undefined
          ? constants.name !== undefined
            ? constants.name
            : namdefault
          : "",
      medium_email:
        constants !== undefined
          ? constants.medium_email !== undefined
            ? constants.medium_email
            : medium_emaildefault
          : "",
      client_email:
        constants !== undefined
          ? constants.client_email !== undefined
            ? constants.client_email
            : client_emaildefault
          : "",
      meeting_id:
        constants !== undefined
          ? constants.meeting_id !== undefined
            ? constants.meeting_id
            : meeting_iddefault
          : "",
      created_at:
        constants !== undefined
          ? constants.created_at !== undefined
            ? constants.created_at
            : created_atdefault
          : "",
          session_date :
           constants !== undefined
          ? constants.session_date !== undefined
            ? constants.session_date
            : session_datedefault
          : "",
      oprater: oprateVal !== undefined ? oprateVal : filterOprater,
      country:
        constants !== undefined
          ? constants.country !== undefined
            ? constants.country
            : countrydefault
          : "",
    };
    filterAllCompletedAppointments(body)
      .then((data) => {
        if (data.data.status) {
          setIsSearching(false);
          dispatch(setCompletedAppointmentsPage(completedAppointmentsPage + 1));
          dispatch(setCompletedAppointmentsrowsPerPage(globalRowsPerPage));
          dispatch(setLoading(false));
          setCompletedAppointments(
            data.data.data.info.map((data) => {
              return { ...data, statusValue: "", nostatusValue: "", noOfAttendees: checkStatus0Values(data),
              noOfWorkers: checkWorkersValues(data), };
            })
          );
          dispatch(
            setAllUpcomingCount(
              JSON.parse(
                JSON.stringify(data.data.data.appointments_count.upcoming)
              )
            )
          );
          dispatch(
            setAllCancelledCount(data.data.data.appointments_count.cancelled)
          );
          dispatch(setAllNoShowCount(data.data.data.appointments_count.noshow));
          dispatch(
            setAllOngoingCount(data.data.data.appointments_count.ongoing)
          );
          dispatch(
            setAllCompletedCount(
              JSON.parse(
                JSON.stringify(data.data.data.appointments_count.completed)
              )
            )
          );
          dispatch(
            setAllRestrictedCount(data.data.data.appointments_count.restrict)
          );
          dispatch(
            setEndedEarlyCount(data.data.data.appointments_count.endearly)
          );
          setListArray(
            list.map((item) => {
              if (item.name === "Upcoming") {
                return {
                  ...item,
                  ...(item.count = data.data.data.appointments_count.upcoming),
                };
              }
              if (item.name === "Completed") {
                return {
                  ...item,
                  ...(item.count = data.data.data.appointments_count.completed),
                };
              }

              if (item.name === "Cancelled") {
                return {
                  ...item,
                  ...(item.count = data.data.data.appointments_count.cancelled),
                };
              }

              if (item.name === "No Shows") {
                return {
                  ...item,
                  ...(item.count = data.data.data.appointments_count.noshow),
                };
              }
              if (item.name === "Restriced") {
                return {
                  ...item,
                  ...(item.count = data.data.data.appointments_count.restrict),
                };
              }
              if (item.name === "Ended Early") {
                return {
                  ...item,
                  ...(item.count = data.data.data.appointments_count.endearly),
                };
              }
              if (item.name === "Ongoing") {
                return {
                  ...item,
                  ...(item.count = data.data.data.appointments_count.ongoing),
                };
              }
            })
          );
        }
      })
      .catch(() => {setIsSearching(false); });
  };
  const filterListCancelledAppointments = (
    constants,
    from,
    value,
    oprateVal
  ) => {
    if (from !== "filter" && constants.session_type !== undefined) {
      setServiceFilterValue("");
      setSearchValuesFilter("");
    }
    const {
      session_type,
      screen_name,
      orderBy = "desc",
      order,
      name,
      medium_email,
      client_email,
      meeting_id,
    } = constants;
    let namdefault = "";
    let screen_namedefault = "";
    let session_typesefault = "";
    let medium_emaildefault = "";
    let client_emaildefault = "";
    let meeting_iddefault = "";
    let created_atdefault = "";
    let session_datedefault ="";
    let countrydefault = "";
    let session_iddefault = "";
    if (
      (constants !== undefined && constants.orderBy) ||
      (from !== undefined && from == "filter")
    ) {
      screen_namedefault =
        constants.screen_name == undefined
          ? searchValue !== undefined && searchValue.screen_name !== undefined
            ? searchValue.screen_name
            : ""
          : constants.screen_name;
      namdefault =
        constants.name == undefined
          ? searchValue !== undefined && searchValue.name !== undefined
            ? searchValue.name
            : ""
          : constants.name;
      session_typesefault =
        constants.session_type == undefined
          ? searchValue !== undefined && searchValue.session_type !== undefined
            ? searchValue.session_type
            : ""
          : constants.session_type;
      medium_emaildefault =
        constants.medium_email == undefined
          ? searchValue !== undefined && searchValue.medium_email !== undefined
            ? searchValue.medium_email
            : ""
          : constants.medium_email;
      client_emaildefault =
        constants.client_email == undefined
          ? searchValue !== undefined && searchValue.client_email !== undefined
            ? searchValue.client_email
            : ""
          : constants.client_email;
      meeting_iddefault =
        constants.meeting_id == undefined
          ? searchValue !== undefined && searchValue.meeting_id !== undefined
            ? searchValue.meeting_id
            : ""
          : constants.meeting_id;
      created_atdefault =
        constants.created_at == undefined
          ? searchValue !== undefined && searchValue.created_at !== undefined
            ? searchValue.created_at
            : ""
          : constants.created_at;
          session_datedefault =
           constants.session_date == undefined
          ? searchValue !== undefined && searchValue.session_date !== undefined
            ? searchValue.session_date
            : ""
          : constants.session_date;
      countrydefault =
        constants.country == undefined
          ? searchValue !== undefined && searchValue.country !== undefined
            ? searchValue.country
            : ""
          : constants.country;
    }
    if (from !== undefined && from == "filter") {
      session_typesefault = "";
    }
    if (constants !== undefined && constants.session_type) {
      session_iddefault = "";
    } else {
      session_iddefault =
        constants.session_id == undefined
          ? searchValueFilter !== undefined &&
            searchValueFilter.session_id !== undefined
            ? searchValueFilter.session_id
            : ""
          : constants.session_id;
    }
    let body = {
      orderBy,
      order,
      screen_name:
        constants !== undefined
          ? constants.screen_name !== undefined
            ? constants.screen_name
            : screen_namedefault
          : "",
      session_type:
        constants !== undefined
          ? constants.session_type !== undefined
            ? constants.session_type
            : session_typesefault
          : "",
      session_id:
        constants !== undefined
          ? constants.session_id !== undefined
            ? constants.session_id
            : session_iddefault
          : "",
      // session_type:
      //   constants !== undefined
      //     ? constants.session_type !== undefined
      //       ? constants.session_type
      //       : ""
      //     : "",
      name:
        constants !== undefined
          ? constants.name !== undefined
            ? constants.name
            : namdefault
          : "",
      medium_email:
        constants !== undefined
          ? constants.medium_email !== undefined
            ? constants.medium_email
            : medium_emaildefault
          : "",
      client_email:
        constants !== undefined
          ? constants.client_email !== undefined
            ? constants.client_email
            : client_emaildefault
          : "",
      meeting_id:
        constants !== undefined
          ? constants.meeting_id !== undefined
            ? constants.meeting_id
            : meeting_iddefault
          : "",
      created_at:
        constants !== undefined
          ? constants.created_at !== undefined
            ? constants.created_at
            : created_atdefault
          : "",
          session_date:
          constants !== undefined
          ? constants.session_date !== undefined
            ? constants.session_date
            : session_datedefault
          : "",
      oprater: oprateVal !== undefined ? oprateVal : filterOprater,
      country:
        constants !== undefined
          ? constants.country !== undefined
            ? constants.country
            : countrydefault
          : "",
    };
    setIsSearching(true);
    filterAllCancelleddAppointments(body)
      .then((data) => {
        if (data.data.status) {
          setIsSearching(false);
          dispatch(setCancelledAppointmentsPage(cancelledAppointmentsPage + 1));
          dispatch(setCancelledAppointmentsrowsPerPage(globalRowsPerPage));
          dispatch(setLoading(false));
          setCanceledAppointments(
            data.data.data.info.map((data) => {
              return { ...data, statusValue: "", nostatusValue: "" };
            })
          );
          dispatch(
            setAllUpcomingCount(
              JSON.parse(
                JSON.stringify(data.data.data.appointments_count.upcoming)
              )
            )
          );
          dispatch(
            setAllCompletedCount(
              JSON.parse(
                JSON.stringify(data.data.data.appointments_count.completed)
              )
            )
          );
          dispatch(
            setAllCancelledCount(data.data.data.appointments_count.cancelled)
          );
          dispatch(setAllNoShowCount(data.data.data.appointments_count.noshow));
          dispatch(
            setAllOngoingCount(data.data.data.appointments_count.ongoing)
          );
          dispatch(
            setAllRestrictedCount(data.data.data.appointments_count.restrict)
          );
          dispatch(
            setEndedEarlyCount(data.data.data.appointments_count.endearly)
          );
          setListArray(
            list.map((item) => {
              if (item.name === "Upcoming") {
                return {
                  ...item,
                  ...(item.count = data.data.data.appointments_count.upcoming),
                };
              }
              if (item.name === "Completed") {
                return {
                  ...item,
                  ...(item.count = data.data.data.appointments_count.completed),
                };
              }

              if (item.name === "Cancelled") {
                return {
                  ...item,
                  ...(item.count = data.data.data.appointments_count.cancelled),
                };
              }

              if (item.name === "No Shows") {
                return {
                  ...item,
                  ...(item.count = data.data.data.appointments_count.noshow),
                };
              }
              if (item.name === "Restriced") {
                return {
                  ...item,
                  ...(item.count = data.data.data.appointments_count.restrict),
                };
              }
              if (item.name === "Ended Early") {
                return {
                  ...item,
                  ...(item.count = data.data.data.appointments_count.endearly),
                };
              }
              if (item.name === "Ongoing") {
                return {
                  ...item,
                  ...(item.count = data.data.data.appointments_count.ongoing),
                };
              }
            })
          );
        }
      })
      .catch(() => {setIsSearching(false); });
  };
  const filterListNoShowdAppointments = (constants, from, value, oprateVal) => {
    if (from !== "filter" && constants.session_type !== undefined) {
      setServiceFilterValue("");
      setSearchValuesFilter("");
    }
    const {
      session_type,
      screen_name,
      orderBy = "desc",
      order,
      name,
      medium_email,
      client_email,
      meeting_id,
    } = constants;
    let namdefault = "";
    let session_typesefault = "";
    let screen_namedefault = "";
    let medium_emaildefault = "";
    let client_emaildefault = "";
    let meeting_iddefault = "";
    let created_atdefault = "";
    let session_datedefault ="";
    let countrydefault = "";
    let session_iddefault = "";
    if (
      (constants !== undefined && constants.orderBy) ||
      (from !== undefined && from == "filter")
    ) {
      screen_namedefault =
        constants.screen_name == undefined
          ? searchValue !== undefined && searchValue.screen_name !== undefined
            ? searchValue.screen_name
            : ""
          : constants.screen_name;
      namdefault =
        constants.name == undefined
          ? searchValue !== undefined && searchValue.name !== undefined
            ? searchValue.name
            : ""
          : constants.name;
      session_typesefault =
        constants.session_type == undefined
          ? searchValue !== undefined && searchValue.session_type !== undefined
            ? searchValue.session_type
            : ""
          : constants.session_type;
      medium_emaildefault =
        constants.medium_email == undefined
          ? searchValue !== undefined && searchValue.medium_email !== undefined
            ? searchValue.medium_email
            : ""
          : constants.medium_email;
      let client_emaildefault =
        constants.client_email == undefined
          ? searchValue !== undefined && searchValue.client_email !== undefined
            ? searchValue.client_email
            : ""
          : constants.client_email;
      meeting_iddefault =
        constants.meeting_id == undefined
          ? searchValue !== undefined && searchValue.meeting_id !== undefined
            ? searchValue.meeting_id
            : ""
          : constants.meeting_id;
      created_atdefault =
        constants.created_at == undefined
          ? searchValue !== undefined && searchValue.created_at !== undefined
            ? searchValue.created_at
            : ""
          : constants.created_at;
          session_datedefault = 
          constants.session_date == undefined
          ? searchValue !== undefined && searchValue.session_date !== undefined
            ? searchValue.session_date
            : ""
          : constants.session_date;
      countrydefault =
        constants.country == undefined
          ? searchValue !== undefined && searchValue.country !== undefined
            ? searchValue.country
            : ""
          : constants.country;
    }
    if (from !== undefined && from == "filter") {
      session_typesefault = "";
    }
    if (constants !== undefined && constants.session_type) {
      session_iddefault = "";
    } else {
      session_iddefault =
        constants.session_id == undefined
          ? searchValueFilter !== undefined &&
            searchValueFilter.session_id !== undefined
            ? searchValueFilter.session_id
            : ""
          : constants.session_id;
    }
    let body = {
      orderBy,
      order,
      screen_name:
        constants !== undefined
          ? constants.screen_name !== undefined
            ? constants.screen_name
            : screen_namedefault
          : "",
      session_type:
        constants !== undefined
          ? constants.session_type !== undefined
            ? constants.session_type
            : session_typesefault
          : "",
      session_id:
        constants !== undefined
          ? constants.session_id !== undefined
            ? constants.session_id
            : session_iddefault
          : "",
      // session_type:
      //   constants !== undefined
      //     ? constants.session_type !== undefined
      //       ? constants.session_type
      //       : ""
      //     : "",
      name:
        constants !== undefined
          ? constants.name !== undefined
            ? constants.name
            : namdefault
          : "",
      medium_email:
        constants !== undefined
          ? constants.medium_email !== undefined
            ? constants.medium_email
            : medium_emaildefault
          : "",
      client_email:
        constants !== undefined
          ? constants.client_email !== undefined
            ? constants.client_email
            : client_emaildefault
          : "",
      meeting_id:
        constants !== undefined
          ? constants.meeting_id !== undefined
            ? constants.meeting_id
            : meeting_iddefault
          : "",
      created_at:
        constants !== undefined
          ? constants.created_at !== undefined
            ? constants.created_at
            : created_atdefault
          : "",
          session_date: 
          constants !== undefined
          ? constants.session_date !== undefined
            ? constants.session_date
            : session_datedefault
          : "",
      oprater: oprateVal !== undefined ? oprateVal : filterOprater,
      country:
        constants !== undefined
          ? constants.country !== undefined
            ? constants.country
            : countrydefault
          : "",
    };
    setIsSearching(true);
    filterAllNoShowAppointments(body)
      .then((data) => {
        if (data.data.status) {
          setIsSearching(false);
          dispatch(setNoShowAppointmentsPage(noshowAppointmentsPage + 1));
          dispatch(setNoShowAppointmentsrowsPerPage(globalRowsPerPage));
          dispatch(setLoading(false));

          setShowAppointments(
            data.data.data.info.map((data) => {
              return { ...data, statusValue: "", nostatusValue: "" };
            })
          );
          dispatch(
            setAllUpcomingCount(
              JSON.parse(
                JSON.stringify(data.data.data.appointments_count.upcoming)
              )
            )
          );
          dispatch(
            setAllCompletedCount(
              JSON.parse(
                JSON.stringify(data.data.data.appointments_count.completed)
              )
            )
          );
          dispatch(
            setAllCancelledCount(data.data.data.appointments_count.cancelled)
          );
          dispatch(setAllNoShowCount(data.data.data.appointments_count.noshow));
          dispatch(
            setAllOngoingCount(data.data.data.appointments_count.ongoing)
          );
          dispatch(
            setAllRestrictedCount(data.data.data.appointments_count.restrict)
          );
          dispatch(
            setEndedEarlyCount(data.data.data.appointments_count.endearly)
          );
          setListArray(
            list.map((item) => {
              if (item.name === "Upcoming") {
                return {
                  ...item,
                  ...(item.count = data.data.data.appointments_count.upcoming),
                };
              }
              if (item.name === "Completed") {
                return {
                  ...item,
                  ...(item.count = data.data.data.appointments_count.completed),
                };
              }

              if (item.name === "Cancelled") {
                return {
                  ...item,
                  ...(item.count = data.data.data.appointments_count.cancelled),
                };
              }

              if (item.name === "No Shows") {
                return {
                  ...item,
                  ...(item.count = data.data.data.appointments_count.noshow),
                };
              }
              if (item.name === "Restriced") {
                return {
                  ...item,
                  ...(item.count = data.data.data.appointments_count.restrict),
                };
              }
              if (item.name === "Ended Early") {
                return {
                  ...item,
                  ...(item.count = data.data.data.appointments_count.endearly),
                };
              }
              if (item.name === "Ongoing") {
                return {
                  ...item,
                  ...(item.count = data.data.data.appointments_count.ongoing),
                };
              }
            })
          );
        }
      })
      .catch(() => { setIsSearching(false);});
  };
  const filterListRestrictedAppointments = (
    constants,
    from,
    value,
    oprateVal
  ) => {
    if (from !== "filter" && constants.session_type !== undefined) {
      setServiceFilterValue("");
      setSearchValuesFilter("");
    }
    const {
      session_type,
      screen_name,
      orderBy = "desc",
      order,
      name,
      medium_email,
      client_email,
      meeting_id,
    } = constants;
    let namdefault = "";
    let session_typesefault = "";
    let screen_namedefault = "";
    let medium_emaildefault = "";
    let client_emaildefault = "";
    let meeting_iddefault = "";
    let created_atdefault = "";
    let session_datedefault = "";
    let countrydefault = "";
    let session_iddefault = "";
    if (
      (constants !== undefined && constants.orderBy) ||
      (from !== undefined && from == "filter")
    ) {
      screen_namedefault =
        constants.screen_name == undefined
          ? searchValue !== undefined && searchValue.screen_name !== undefined
            ? searchValue.screen_name
            : ""
          : constants.screen_name;
      namdefault =
        constants.name == undefined
          ? searchValue !== undefined && searchValue.name !== undefined
            ? searchValue.name
            : ""
          : constants.name;
      session_typesefault =
        constants.session_type == undefined
          ? searchValue !== undefined && searchValue.session_type !== undefined
            ? searchValue.session_type
            : ""
          : constants.session_type;
      medium_emaildefault =
        constants.medium_email == undefined
          ? searchValue !== undefined && searchValue.medium_email !== undefined
            ? searchValue.medium_email
            : ""
          : constants.medium_email;
      client_emaildefault =
        constants.client_email == undefined
          ? searchValue !== undefined && searchValue.client_email !== undefined
            ? searchValue.client_email
            : ""
          : constants.client_email;
      meeting_iddefault =
        constants.meeting_id == undefined
          ? searchValue !== undefined && searchValue.meeting_id !== undefined
            ? searchValue.meeting_id
            : ""
          : constants.meeting_id;
      created_atdefault =
        constants.created_at == undefined
          ? searchValue !== undefined && searchValue.created_at !== undefined
            ? searchValue.created_at
            : ""
          : constants.created_at;
          session_datedefault =
          constants.session_date == undefined
          ? searchValue !== undefined && searchValue.session_date !== undefined
            ? searchValue.session_date
            : ""
          : constants.session_date;
      countrydefault =
        constants.country == undefined
          ? searchValue !== undefined && searchValue.country !== undefined
            ? searchValue.country
            : ""
          : constants.country;
    }
    if (from !== undefined && from == "filter") {
      session_typesefault = "";
    }
    if (constants !== undefined && constants.session_type) {
      session_iddefault = "";
    } else {
      session_iddefault =
        constants.session_id == undefined
          ? searchValueFilter !== undefined &&
            searchValueFilter.session_id !== undefined
            ? searchValueFilter.session_id
            : ""
          : constants.session_id;
    }
    let body = {
      orderBy,
      order,
      screen_name:
        constants !== undefined
          ? constants.screen_name !== undefined
            ? constants.screen_name
            : screen_namedefault
          : "",
      session_type:
        constants !== undefined
          ? constants.session_type !== undefined
            ? constants.session_type
            : session_typesefault
          : "",
      session_id:
        constants !== undefined
          ? constants.session_id !== undefined
            ? constants.session_id
            : session_iddefault
          : "",
      // session_type:
      //   constants !== undefined
      //     ? constants.session_type !== undefined
      //       ? constants.session_type
      //       : ""
      //     : "",
      name:
        constants !== undefined
          ? constants.name !== undefined
            ? constants.name
            : namdefault
          : "",
      medium_email:
        constants !== undefined
          ? constants.medium_email !== undefined
            ? constants.medium_email
            : medium_emaildefault
          : "",
      client_email:
        constants !== undefined
          ? constants.client_email !== undefined
            ? constants.client_email
            : client_emaildefault
          : "",
      meeting_id:
        constants !== undefined
          ? constants.meeting_id !== undefined
            ? constants.meeting_id
            : meeting_iddefault
          : "",
      created_at:
        constants !== undefined
          ? constants.created_at !== undefined
            ? constants.created_at
            : created_atdefault
          : "",
          session_date : 
          constants !== undefined
          ? constants.session_date !== undefined
            ? constants.session_date
            : session_datedefault
          : "",
      oprater: oprateVal !== undefined ? oprateVal : filterOprater,
      country:
        constants !== undefined
          ? constants.country !== undefined
            ? constants.country
            : countrydefault
          : "",
    };
    setIsSearching(true);
    filterAllRestrictedAppointments(body)
      .then((data) => {
        if (data.data.status) {
          setIsSearching(false);
          dispatch(
            setrestrictedAppointmentsPage(restrictedAppointmentsPage + 1)
          );
          dispatch(setrestrictedAppointmentsrowsPerPage(globalRowsPerPage));
          dispatch(setLoading(false));
          //
          setRestrictedAppontmets(
            data.data.data.info.map((data) => {
              return { ...data, statusValue: "", nostatusValue: "" };
            })
          );
          dispatch(
            setAllUpcomingCount(
              JSON.parse(
                JSON.stringify(data.data.data.appointments_count.upcoming)
              )
            )
          );
          dispatch(
            setAllCompletedCount(
              JSON.parse(
                JSON.stringify(data.data.data.appointments_count.completed)
              )
            )
          );
          dispatch(
            setAllCancelledCount(data.data.data.appointments_count.cancelled)
          );
          dispatch(setAllNoShowCount(data.data.data.appointments_count.noshow));
          dispatch(
            setAllOngoingCount(data.data.data.appointments_count.ongoing)
          );
          dispatch(
            setAllRestrictedCount(data.data.data.appointments_count.restrict)
          );
          dispatch(
            setEndedEarlyCount(data.data.data.appointments_count.endearly)
          );
          setListArray(
            list.map((item) => {
              if (item.name === "Upcoming") {
                return {
                  ...item,
                  ...(item.count = data.data.data.appointments_count.upcoming),
                };
              }
              if (item.name === "Completed") {
                return {
                  ...item,
                  ...(item.count = data.data.data.appointments_count.completed),
                };
              }

              if (item.name === "Cancelled") {
                return {
                  ...item,
                  ...(item.count = data.data.data.appointments_count.cancelled),
                };
              }

              if (item.name === "No Shows") {
                return {
                  ...item,
                  ...(item.count = data.data.data.appointments_count.noshow),
                };
              }
              if (item.name === "Restriced") {
                return {
                  ...item,
                  ...(item.count = data.data.data.appointments_count.restrict),
                };
              }
              if (item.name === "Ended Early") {
                return {
                  ...item,
                  ...(item.count = data.data.data.appointments_count.endearly),
                };
              }
              if (item.name === "Ongoing") {
                return {
                  ...item,
                  ...(item.count = data.data.data.appointments_count.ongoing),
                };
              }
            })
          );
        }
        dispatch(setLoading(false));
      })
      .catch(() => {
        dispatch(setLoading(false));
        setIsSearching(false);
      });
  };

  const filterListEndedEarlyAppointments = (
    constants,
    from,
    value,
    oprateVal
  ) => {
    if (from !== "filter" && constants.session_type !== undefined) {
      setServiceFilterValue("");
      setSearchValuesFilter("");
    }
    const {
      session_type,
      screen_name,
      orderBy = "desc",
      order,
      name,
      medium_email,
      client_email,
      meeting_id,
    } = constants;
    let namdefault = "";
    let session_typesefault = "";
    let screen_namedefault = "";
    let medium_emaildefault = "";
    let client_emaildefault = "";
    let meeting_iddefault = "";
    let created_atdefault = "";
    let session_datedefault = "";
    let countrydefault = "";
    let session_iddefault = "";
    if (
      (constants !== undefined && constants.orderBy) ||
      (from !== undefined && from == "filter")
    ) {
      screen_namedefault =
        constants.screen_name == undefined
          ? searchValue !== undefined && searchValue.screen_name !== undefined
            ? searchValue.screen_name
            : ""
          : constants.screen_name;
      namdefault =
        constants.name == undefined
          ? searchValue !== undefined && searchValue.name !== undefined
            ? searchValue.name
            : ""
          : constants.name;
      session_typesefault =
        constants.session_type == undefined
          ? searchValue !== undefined && searchValue.session_type !== undefined
            ? searchValue.session_type
            : ""
          : constants.session_type;
      medium_emaildefault =
        constants.medium_email == undefined
          ? searchValue !== undefined && searchValue.medium_email !== undefined
            ? searchValue.medium_email
            : ""
          : constants.medium_email;
      client_emaildefault =
        constants.client_email == undefined
          ? searchValue !== undefined && searchValue.client_email !== undefined
            ? searchValue.client_email
            : ""
          : constants.client_email;
      meeting_iddefault =
        constants.meeting_id == undefined
          ? searchValue !== undefined && searchValue.meeting_id !== undefined
            ? searchValue.meeting_id
            : ""
          : constants.meeting_id;
      created_atdefault =
        constants.created_at == undefined
          ? searchValue !== undefined && searchValue.created_at !== undefined
            ? searchValue.created_at
            : ""
          : constants.created_at;
          session_datedefault = 
           constants.session_date == undefined
          ? searchValue !== undefined && searchValue.session_date !== undefined
            ? searchValue.session_date
            : ""
          : constants.session_date;
      countrydefault =
        constants.country == undefined
          ? searchValue !== undefined && searchValue.country !== undefined
            ? searchValue.country
            : ""
          : constants.country;
    }
    if (from !== undefined && from == "filter") {
      session_typesefault = "";
    }
    if (constants !== undefined && constants.session_type) {
      session_iddefault = "";
    } else {
      session_iddefault =
        constants.session_id == undefined
          ? searchValueFilter !== undefined &&
            searchValueFilter.session_id !== undefined
            ? searchValueFilter.session_id
            : ""
          : constants.session_id;
    }
    let body = {
      orderBy,
      order,
      screen_name:
        constants !== undefined
          ? constants.screen_name !== undefined
            ? constants.screen_name
            : screen_namedefault
          : "",
      session_type:
        constants !== undefined
          ? constants.session_type !== undefined
            ? constants.session_type
            : session_typesefault
          : "",
      session_id:
        constants !== undefined
          ? constants.session_id !== undefined
            ? constants.session_id
            : session_iddefault
          : "",
      // session_type:
      //   constants !== undefined
      //     ? constants.session_type !== undefined
      //       ? constants.session_type
      //       : ""
      //     : "",
      name:
        constants !== undefined
          ? constants.name !== undefined
            ? constants.name
            : namdefault
          : "",
      medium_email:
        constants !== undefined
          ? constants.medium_email !== undefined
            ? constants.medium_email
            : medium_emaildefault
          : "",
      client_email:
        constants !== undefined
          ? constants.client_email !== undefined
            ? constants.client_email
            : client_emaildefault
          : "",
      meeting_id:
        constants !== undefined
          ? constants.meeting_id !== undefined
            ? constants.meeting_id
            : meeting_iddefault
          : "",
      created_at:
        constants !== undefined
          ? constants.created_at !== undefined
            ? constants.created_at
            : created_atdefault
          : "",
          session_date : 
          constants !== undefined
          ? constants.session_date !== undefined
            ? constants.session_date
            : session_datedefault
          : "",
      oprater: oprateVal !== undefined ? oprateVal : filterOprater,
      country:
        constants !== undefined
          ? constants.country !== undefined
            ? constants.country
            : countrydefault
          : "",
    };
    setIsSearching(true);
    filterAllEndedEarlyAppointments(body)
      .then((data) => {
        if (data.data.status) {
          setIsSearching(false);
          dispatch(
            setendedEarlyAppointmentsPage(endedEarlyAppointmentsPage + 1)
          );
          dispatch(setendedEarlyAppointmentsrowsPerPage(globalRowsPerPage));
          dispatch(setLoading(false));
          //
          setEndedEarlyAppontmets(
            data.data.data.info.map((data) => {
              return { ...data, statusValue: "", nostatusValue: "" };
            })
          );
          dispatch(
            setAllUpcomingCount(
              JSON.parse(
                JSON.stringify(data.data.data.appointments_count.upcoming)
              )
            )
          );
          dispatch(
            setAllCompletedCount(
              JSON.parse(
                JSON.stringify(data.data.data.appointments_count.completed)
              )
            )
          );
          dispatch(
            setAllCancelledCount(data.data.data.appointments_count.cancelled)
          );
          dispatch(setAllNoShowCount(data.data.data.appointments_count.noshow));
          dispatch(
            setAllOngoingCount(data.data.data.appointments_count.ongoing)
          );
          dispatch(
            setAllRestrictedCount(data.data.data.appointments_count.restrict)
          );
          dispatch(
            setEndedEarlyCount(data.data.data.appointments_count.endearly)
          );
          setListArray(
            list.map((item) => {
              if (item.name === "Upcoming") {
                return {
                  ...item,
                  ...(item.count = data.data.data.appointments_count.upcoming),
                };
              }
              if (item.name === "Completed") {
                return {
                  ...item,
                  ...(item.count = data.data.data.appointments_count.completed),
                };
              }

              if (item.name === "Cancelled") {
                return {
                  ...item,
                  ...(item.count = data.data.data.appointments_count.cancelled),
                };
              }

              if (item.name === "No Shows") {
                return {
                  ...item,
                  ...(item.count = data.data.data.appointments_count.noshow),
                };
              }
              if (item.name === "Restriced") {
                return {
                  ...item,
                  ...(item.count = data.data.data.appointments_count.restrict),
                };
              }
              if (item.name === "Ended Early") {
                return {
                  ...item,
                  ...(item.count = data.data.data.appointments_count.endearly),
                };
              }
              if (item.name === "Ongoing") {
                return {
                  ...item,
                  ...(item.count = data.data.data.appointments_count.ongoing),
                };
              }
            })
          );
        }
        dispatch(setLoading(false));
      })
      .catch(() => {
        dispatch(setLoading(false));
        setIsSearching(false);
      });
  };
  // const filterListOngoingAppointments = (constants) => {
  //   const {
  //     session_type,
  //     screen_name,
  //     orderBy = "asc",
  //     name,
  //     medium_email,
  //     client_email,
  //     meeting_id,
  //   } = constants;
  //   let body = {
  //     session_type,
  //     screen_name,
  //     orderBy,
  //     name,
  //     medium_email,
  //     client_email,
  //     meeting_id,
  //   };
  //   filterAllOngoingAppointments(body)
  //     .then((data) => {
  //       if (data.data.status) {
  //         dispatch(setCompletedAppointmentsPage(2));
  //         dispatch(setCompletedAppointmentsrowsPerPage(10));
  //         dispatch(setLoading(false));
  //         setOngoingAppointments(
  //           data.data.data.info.map((data) => {
  //             return { ...data, statusValue: "", nostatusValue: "" };
  //           })
  //         );
  //         dispatch(
  //           setAllUpcomingCount(
  //             JSON.parse(
  //               JSON.stringify(data.data.data.appointments_count.upcoming)
  //             )
  //           )
  //         );
  //         dispatch(
  //           setAllCompletedCount(
  //             JSON.parse(
  //               JSON.stringify(data.data.data.appointments_count.completed)
  //             )
  //           )
  //         );
  //         setListArray(
  //           list.map((item) => {
  //             if (item.name === "Upcoming") {
  //               return {
  //                 ...item,
  //                 ...(item.count = data.data.data.appointments_count.upcoming),
  //               };
  //             }
  //             if (item.name === "Completed") {
  //               return {
  //                 ...item,
  //                 ...(item.count = data.data.data.appointments_count.completed),
  //               };
  //             }

  //             if (item.name === "Cancelled") {
  //               return {
  //                 ...item,
  //                 ...(item.count =  data.data.data.appointments_count.cancelled),
  //               };
  //             }

  //             if (item.name === "No Shows") {
  //               return {
  //                 ...item,
  //                 ...(item.count =  data.data.data.appointments_count.noshow),
  //               };
  //             }
  //             if (item.name === "Ongoing") {
  //               return {
  //                 ...item,
  //                 ...(item.count =  data.data.data.appointments_count.ongoing),
  //               };
  //             }
  //           })
  //         );
  //       }
  //     })
  //     .catch(() => {});
  // };

  const changeHandlerFilter = (e, filterName) => {
    // setFilterValues('screen_name')
    // setSearchValues({ screen_name: '' })
    let value = e;
    let multiSessionType = "";
    //setSearchValues(value)
    if (Array.isArray(value)) {
      // Check if "other" exists in the selected values
      //setServiceFilterValue("");
      multiSessionType = value.map((item) => item.value).join(",");
    }
    // Single selection
    else if (value) {
      multiSessionType = value.value; // Store single value
    }
    if (searchValue !== undefined && searchValue.session_type) {
      setSearchValues("");
    }
    setSearchValuesFilter({ session_id: multiSessionType });
    console.log("Multi Session Type:", multiSessionType); // Will show like: "1,3,4"
    setServiceFilterValue(value);
    // if (filterName === "upcoming") {
    //   filterListUpcomingAppointments(
    //     { session_id: multiSessionType },
    //     "filter",
    //     value
    //   );
    // } else if (filterName === "completely") {
    //   filterListCompletedAppointments(
    //     { session_id: multiSessionType },
    //     "filter",
    //     value
    //   );
    // } else if (filterName === "cancelled") {
    //   filterListCancelledAppointments(
    //     { session_id: multiSessionType },
    //     "filter",
    //     value
    //   );
    // } else if (filterName === "noshows") {
    //   filterListNoShowdAppointments(
    //     { session_id: multiSessionType },
    //     "filter",
    //     value
    //   );
    // } else if (filterName === "restricted") {
    //   filterListRestrictedAppointments(
    //     { session_id: multiSessionType },
    //     "filter",
    //     value
    //   );
    // } else if (filterName === "endedearly") {
    //   filterListEndedEarlyAppointments(
    //     { session_id: multiSessionType },
    //     "filter",
    //     value
    //   );
    // }
    // else if (filterName === 'ongoing') {
    //   (searchValue, 'filter', value);
    // }
  };
  const filterReset = () => {
    setServiceFilterValue("");
    setSearchValuesFilter("");
    setFilterValues("screen_name");
    setSearchValues("");
    setShowOprater(false);
    setLoadAll(true);
    let data = {
      page: 1,
      rowsPerPage: 25,
      session_type: "",
      medium_name: "",
      name: "",
      medium_email: "",
      client_email: "",
      meeting_id: "",
      created_at: "",
      session_date:"",
      orderBy: "",
      order: "",
      loadAll:"yes",
    };
    
    if (activeTab === 0) {
     
      getUpComingAppointments(data, activeTab);
    }
    if (activeTab === 1) {
      getCompletedAppointments(data, activeTab);
    }
    if (activeTab === 2) {
      getCancelledAppointments(data, activeTab);
    }
    if (activeTab === 3) {
      getNoShowsAppointments(data, activeTab);
    }
    if (activeTab === 4) {
      getRestrictedAppointments(data, activeTab);
    }
    if (activeTab === 5) {
      getEndedEarlyAppointments(data, activeTab);
    }
    if (activeTab === 6) {
      getOngoingAppointments(data, activeTab);
    }
  };

  const createStringShared = () => {
    return (
      `screen_name=${searchValue !== undefined ? (searchValue.screen_name !== undefined ? searchValue.screen_name : "") : ""}` +
      `&session_type=${searchValue !== undefined ? (searchValue.session_type !== undefined ? searchValue.session_type : "") : ""}` +
      `&session_id=${searchValue !== undefined ? (searchValueFilter !== undefined && searchValueFilter.session_id !== undefined ? searchValueFilter.session_id : "") : ""}` +
      `&name=${searchValue !== undefined ? (searchValue.name !== undefined ? searchValue.name : "") : ""}` +
      `&medium_email=${searchValue !== undefined ? (searchValue.medium_email !== undefined ? searchValue.medium_email : "") : ""}` +
      `&client_email=${searchValue !== undefined ? (searchValue.client_email !== undefined ? searchValue.client_email : "") : ""}` +
      `&meeting_id=${searchValue !== undefined ? (searchValue.meeting_id !== undefined ? searchValue.meeting_id : "") : ""}` +
      `&created_at=${searchValue !== undefined && searchValue.created_at !== undefined ? searchValue.created_at : ""}` +
      `&session_date=${searchValue !== undefined && searchValue.session_date !== undefined ? searchValue.session_date : ""}` +
      `&oprater=${filterOprater !== undefined ? filterOprater : ""}` +
      `&country=${searchValue !== undefined && searchValue.country !== undefined ? searchValue.country : ""}`
    );
  };

  const fliterdataShared = (name, oprater) => {
    const newValues = { filterValues: { ...name }, operator: oprater };
    filtersRef.current = newValues;
  };

  const filterListShared = (fv, op) => {
    if (activeTab === 0) filterListUpcomingAppointments(fv, op);
    else if (activeTab === 1) filterListCompletedAppointments(fv, op);
    else if (activeTab === 2) filterListCancelledAppointments(fv, op);
    else if (activeTab === 3) filterListNoShowdAppointments(fv, op);
    else if (activeTab === 4) filterListRestrictedAppointments(fv, op);
    else if (activeTab === 5) filterListEndedEarlyAppointments(fv, op);
  };

  const TAB_EXPORT_TYPE = [
    { type: "upcoming", value: 0 },
    { type: "completed", value: 1 },
    { type: "cancelled", value: 3 },
    { type: "show", value: 2 },
    { type: "restrict", value: 5 },
    { type: "endearly", value: 4 },
    { type: "ongoing", value: 0 },
  ];

  const exportDataShared = () => {
    const { type, value } = TAB_EXPORT_TYPE[activeTab] || TAB_EXPORT_TYPE[0];
    ExportData({ appoitment_type: type, appoitment_value: value, queryString: createStringShared() })
      .then((data) => { if (data.data.status) toast.success(data.data.message, { position: "top-center" }); })
      .catch(() => {});
  };

  const exportAllDataShared = () => {
    const { type, value } = TAB_EXPORT_TYPE[activeTab] || TAB_EXPORT_TYPE[0];
    ExportData({ appoitment_type: type, appoitment_value: value, queryString: "" })
      .then((data) => { if (data.data.status) toast.success("All data exported successfully", { position: "top-center" }); })
      .catch(() => {});
  };

  // ── Create Appointment modals (rendered here so they work on every tab) ──
  const [allClients, setAllClients] = useState([]);
  const [allMediums, setAllMediums] = useState([]);
  const [allAttendeesMedium, setAllAttendeesMedium] = useState([]);
  const [subsessionsList, setSubsessionsList] = useState([]);

  const getAllFreeClients = (data) => {
    getAllClients(data)
      .then((res) => { if (res.data.status) setAllClients(res.data.data.data); })
      .catch((err) => console.log(err));
  };
  const getMediumList = (item) => {
    getAllMediums(item)
      .then((res) => { if (res.data.status) setAllMediums(res.data.data.data); })
      .catch((err) => console.log(err));
  };
  const getMediumAttendees = (item) => {
    getAllMediums(item)
      .then((res) => { if (res.data.status) setAllAttendeesMedium(res.data.data.data); })
      .catch((err) => console.log(err));
  };
  const getSubsessions = (id) => {
    getCreateAppointmentSubseesions(id)
      .then((res) => { if (res.data.status) setSubsessionsList(res.data.data); })
      .catch(() => {});
  };

  const handleCreateAppointment = () => {
    window.loadModal2("#SelectAppointmentType", "show");
  };
  const handleTypeSelect = (type) => {
    if (type === "client_to_medium") {
      window.loadModal2("#CreateNewAppointment", "show");
    } else if (type === "medium_to_medium") {
      window.loadModal2("#CreateNewMediumAppointment", "show");
    }
  };

  useEffect(() => {
    Pusher.logToConsole = true;
    var pusher = new Pusher("823ab72ed6ecd563b8c8", {
      cluster: "ap2",
    });

    var channel = pusher.subscribe("zoom-link");
    channel.bind("App\\Events\\ZoomLinkUpdate", function (data) {

      if (data.appointment_id && data.meeting_link) {
        setmeetingLinkRegenerated(data)
      }
    });
  }, []);

  useEffect(() => {
    console.log(upcomingAppointment, "upcomingAppointment")
    if (meetingLinkRegenerated.appointment_id && meetingLinkRegenerated.meeting_link) {
      let mapin = upcomingAppointment.map((info) => {
        if (info.id == meetingLinkRegenerated.appointment_id) {
          return {
            ...info,
            meeting_link: meetingLinkRegenerated.meeting_link,
          };
        } else {
          return {
            ...info,
          };
        }
      });
      console.log(mapin, "mapin");
      setUpcomingAppointments(mapin);
    }

  }, [meetingLinkRegenerated])
  const exportTable = (appointmentType,appoitmentValue) => {

    let body = {
      appointment_type: appointmentType,
      appoitment_value: appoitmentValue,
      page: 1,
      rowsPerPage: 10,
      screen_name:
        searchValue !== undefined
          ? searchValue.screen_name !== undefined
            ? searchValue.screen_name
            : ""
          : "",
      session_type:
        searchValue !== undefined
          ? searchValue.session_type !== undefined
            ? searchValue.session_type
            : ""
          : "",
      session_id: "",
      name:
        searchValue !== undefined
          ? searchValue.name !== undefined
            ? searchValue.name
            : ""
          : "",
      medium_email:
        searchValue !== undefined
          ? searchValue.medium_email !== undefined
            ? searchValue.medium_email
            : ""
          : "",
      client_email:
        searchValue !== undefined
          ? searchValue.client_email !== undefined
            ? searchValue.client_email
            : ""
          : "",
      meeting_id:
        searchValue !== undefined
          ? searchValue.meeting_id !== undefined
            ? searchValue.meeting_id
            : ""
          : "",
      created_at:
        searchValue !== undefined && searchValue.created_at !== undefined
          ? searchValue.created_at
          : "",
          session_date:
          searchValue !== undefined && searchValue.session_date !== undefined
          ? searchValue.session_date
          : "",
    };
    exportAppointments(body)
      .then((data) => {
        if (data.data.status) {
          toast.success("Export request send successfully!!", {
            position: "top-center",
          });
        } else {
          toast.error("Something went wrong", { position: "top-center" });
        }
      })
      .catch(() => { });
  };

  const downloadExport = (activeTab) => {
    let Tab = "upcoming";
    let apaointmentValue = 0;
    if (activeTab === 0) {
      Tab = "upcoming";
      apaointmentValue = 0;
    }
    if (activeTab === 1) {
      Tab = "completed";
      apaointmentValue = 1;
    }
    if (activeTab === 2) {
      Tab = "cancelled";
      apaointmentValue = 3;
    }
    if (activeTab === 3) {
      Tab = "show";
      apaointmentValue = 2;
    }
    if (activeTab === 4) {
      Tab = "restrict";
      apaointmentValue = 5;
    }
    if (activeTab === 5) {
      Tab = "endearly";
      apaointmentValue = 4;
    }
    if (activeTab === 6) {
      Tab = "ongoing";
      apaointmentValue = 0;
    }
    let body = {
      appoitment_type: Tab,
    };

    exportDownloadAppointments(body)
      .then((data) => {
        if (data.data.status) {
          console.log(data.data.data);
          setExportDownload(data.data.data);
        } else {
          // toast.error("Something went wrong", { position: "top-center" });
        }
      })
      .catch(() => { });
    //setExportDownload
  };
  const onChange = (e) => {
    e.stopPropagation();
    let body = {
      include_exclude_test_appointments: checked ? 0 : 1
    }
    updateIncludeExcludeTestAppointments(body).then((data) => {
      if (data.data.status) {

        setChecked(!checked);
        filterReset();
      }
    }).catch(() => {

    })
  };
  useEffect(() => {
    setChecked(include_exclude_test_appointments === 1 ? true : false)
  }, [include_exclude_test_appointments])
  const transferCount = (fromName, toName) => {
  setListArray((prevList) =>
    prevList.map((item) => {
      if (item.name === fromName) {
        // Decrease 1 from source, but not below 0
        return { ...item, count: Math.max(item.count - 1, 0) };
      }
      if (item.name === toName) {
        // Add 1 to destination
        return { ...item, count: item.count + 1 };
      }
      return item;
    })
  );
};
const actionData = (activeTab) =>{
  let info = JSON.parse(localStorage.getItem('paginationAppointment'))
  const data1 = {
      page: 1,
      rowsPerPage: 25,
      screen_name:
        searchValue !== undefined
          ? searchValue.screen_name !== undefined
            ? searchValue.screen_name
            : ""
          : "",
      session_type:
        searchValue !== undefined
          ? searchValue.session_type !== undefined
            ? searchValue.session_type
            : ""
          : "",
      session_id:
        searchValue !== undefined
          ? searchValueFilter.session_id !== undefined
            ? searchValueFilter.session_id
            : ""
          : "",
      // session_type:
      //   searchValue !== undefined
      //     ? searchValue.session_type !== undefined
      //       ? searchValue.session_type
      //       : ""
      //     : "",
      name:
        searchValue !== undefined
          ? searchValue.name !== undefined
            ? searchValue.name
            : ""
          : "",
      medium_email:
        searchValue !== undefined
          ? searchValue.medium_email !== undefined
            ? searchValue.medium_email
            : ""
          : "",
      client_email:
        searchValue !== undefined
          ? searchValue.client_email !== undefined
            ? searchValue.client_email
            : ""
          : "",
      meeting_id:
        searchValue !== undefined
          ? searchValue.meeting_id !== undefined
            ? searchValue.meeting_id
            : ""
          : "",
      created_at:
        searchValue !== undefined && searchValue.created_at !== undefined
          ? searchValue.created_at
          : "",
          session_date : 
          searchValue !== undefined && searchValue.session_date !== undefined
          ? searchValue.session_date
          : "",
      oprater: filterOprater !== undefined ? filterOprater : "",
      country:
        searchValue !== undefined && searchValue.country !== undefined
          ? searchValue.country
          : "",
    };
    if (activeTab === 0) {
      getUpComingAppointments(data1, activeTab);
    }
        if (activeTab === 1) {
      getCompletedAppointments(data1, activeTab);
    }
}
const showdata = (activeTab) =>{
  let info = JSON.parse(localStorage.getItem('paginationAppointment'))
  const data1 = {
      page:info !== null ? info.page : 1,
      rowsPerPage: info !== null ? info.rowsPerPage : 25,
      screen_name:
        searchValue !== undefined
          ? searchValue.screen_name !== undefined
            ? searchValue.screen_name
            : ""
          : "",
      session_type:
        searchValue !== undefined
          ? searchValue.session_type !== undefined
            ? searchValue.session_type
            : ""
          : "",
      session_id:
        searchValue !== undefined
          ? searchValueFilter.session_id !== undefined
            ? searchValueFilter.session_id
            : ""
          : "",
      // session_type:
      //   searchValue !== undefined
      //     ? searchValue.session_type !== undefined
      //       ? searchValue.session_type
      //       : ""
      //     : "",
      name:
        searchValue !== undefined
          ? searchValue.name !== undefined
            ? searchValue.name
            : ""
          : "",
      medium_email:
        searchValue !== undefined
          ? searchValue.medium_email !== undefined
            ? searchValue.medium_email
            : ""
          : "",
      client_email:
        searchValue !== undefined
          ? searchValue.client_email !== undefined
            ? searchValue.client_email
            : ""
          : "",
      meeting_id:
        searchValue !== undefined
          ? searchValue.meeting_id !== undefined
            ? searchValue.meeting_id
            : ""
          : "",
      created_at:
        searchValue !== undefined && searchValue.created_at !== undefined
          ? searchValue.created_at
          : "",
          session_date : 
          searchValue !== undefined && searchValue.session_date !== undefined
          ? searchValue.session_date
          : "",
      oprater: filterOprater !== undefined ? filterOprater : "",
      country:
        searchValue !== undefined && searchValue.country !== undefined
          ? searchValue.country
          : "",
    };
    if (activeTab === 0) {
      getUpComingAppointments(data1, activeTab);
    }
}
  return (
    <div className="all-medium-page">
      {/* ── Timezone — top right ── */}
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "12px", marginTop: "12px", overflow: "hidden" }}>
        <select
          onChange={changeTimeZoneHandler}
          className="select-box-timezone pointer"
value={(timezoneData.find((item) => item.front_name === timezone) || {}).id || ""}
        >
          <option disabled value="">
            Change Timezone
          </option>
          {timezoneData.map((item) => (
            <option key={item.id} value={item.id}>{item.front_name}</option>
          ))}
        </select>
      </div>
      {/* ── Toggle + action buttons on one line ── */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: "8px", marginBottom: "16px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <div className="toggle-button-cover" style={{ position: "relative", display: "block", width: "74px", height: "36px", flexShrink: 0 }}>
            <div className="button-cover">
              <div className="button r" id="button-1" onClick={onChange}>
                <input
                  id={``}
                  type="checkbox"
                  checked={checked}
                  name="test_user"
                  className="checkbox"
                  readOnly
                />
                <div className="knobs"></div>
                <div className="layer"></div>
              </div>
            </div>
          </div>
          <p style={{ margin: 0 }}>Test Appointments</p>
        </div>
        <div className="export-top-row" style={{ display: "flex", flexWrap: "wrap", justifyContent: "flex-end", gap: "8px" }}>
        <Button
          status={0}
          type="button"
          onClick={exportDataShared}
          className="resend-btn min-width-135 create-app-sm-screen"
          title="Export Table"
        />
        <Button
          status={0}
          type="button"
          onClick={exportAllDataShared}
          className="resend-btn min-width-135 create-app-sm-screen"
          title="Export All"
        />
        {exportDownload !== "" && (
          <Button
            status={0}
            type="button"
            onClick={() => window.open(`${exportDownload.path}`, '_blank')}
            className="resend-btn min-width-210 create-app-sm-screen"
            title="Download Export"
          />
        )}
        <Button
          status={0}
          type="button"
          onClick={handleCreateAppointment}
          className="resend-btn min-width-210 create-app-sm-screen"
          title="Create Appointment"
        />
        </div>
      </div>
      {/* ── Filter bar — sits above tabs ── */}
      <div className="d-flex justify-content-end gap-10 flex-wrap bottomClass">
        <Search
          callApi={fliterdataShared}
          callNewApi={filterListShared}
          list={filterList}
          setSearchValues={setSearchValues}
          setFilterValues={setFilterValues}
          searchValue={searchValue}
          filterValues={filterValues}
          setOptionsList={setOptionsList}
          optionsList={optionsList}
          operatorList={operatorList}
          setOperatorList={setOperatorList}
          showOprater={showOprater}
          setShowOprater={setShowOprater}
          setFilterOprater={setFilterOprater}
          filterOprater={filterOprater}
          setFilterValueOptions={setFilterValueOptions}
          filterValueOptions={filterValueOptions}
          isOperator={1}
          isDatepickerShow={1}
          isAppointment={1}
          setServiceTypeShow={setServiceTypeShow}
          serviceTypeShow={serviceTypeShow}
          changeHandlerFilter={changeHandlerFilter}
          serviceTypeList={serviceTypeList}
          serviceFilterValue={serviceFilterValue}
          setIsFilterDirty={setIsFilterDirty}
          isSearchBtn={1}
        />
        <Button
          status={0}
          type="button"
          onClick={filterReset}
          className="resend-btn width-100px reset-btn-123 appt-load-all-btn"
          title="Load All"
        />
      </div>
      <AppointmentConfirmModal id="SelectAppointmentType" onSelect={handleTypeSelect} />
      <CreateNewAppointment
        getAllFreeClients={getAllFreeClients}
        getMediumList={getMediumList}
        mediums={allMediums}
        clients={allClients}
        getAllAppointmentsList={getUpComingAppointments}
        activeTab={0}
        getSubsessions={getSubsessions}
        subsessionsList={subsessionsList}
        setAllMediums={setAllMediums}
        setAllClients={setAllClients}
      />
      <CreateNewMediumAppointment
        getAllFreeClients={getAllFreeClients}
        getMediumList={getMediumList}
        getMediumAttendees={getMediumAttendees}
        mediums={allMediums}
        clients={allClients}
        getAllAppointmentsList={getUpComingAppointments}
        activeTab={0}
        getSubsessions={getSubsessions}
        subsessionsList={subsessionsList}
        setAllMediums={setAllMediums}
        setAllAttendeesMedium={setAllAttendeesMedium}
        allAttendeesMedium={allAttendeesMedium}
        setAllClients={setAllClients}
      />
      <Tabs active={activeTab} list={listArray} setActiveTab={setActiveTab}  />
      <ul className="tabs-content">
        {console.log(upcomingAppointment, "upcomingAppointment")}
        <TabPanel id={0} activeTab={activeTab}>
          <Upcoming
            actionData={actionData}
            showdata={showdata}
            upcomingAppointments={upcomingAppointment}
            setUpcomingAppointments={setUpcomingAppointments}
            changeHandler={changeHandler}
            filterListAppointments={filterListUpcomingAppointments}
            filterReset={filterReset}
            getPaginationData={(data) => getPaginationData(data, activeTab)}
            setFilterValues={setFilterValues}
            setSearchValues={setSearchValues}
            getAllAppointmentsList={getUpComingAppointments}
            activeTab={activeTab}
            upcomingAppointmentsPage={upcomingAppointmentsPage}
            upcomingAppointmentsrowsPerPage={upcomingAppointmentsrowsPerPage}
            searchValue={searchValue}
            filterValues={filterValues}
            serviceTypeList={serviceTypeList}
            changeHandlerFilter={changeHandlerFilter}
            serviceFilterValue={serviceFilterValue}
            setSortingNameOrderBy={setSortingNameOrderBy}
            setSortingTabType={setSortingTabType}
            setOptionsList={setOptionsList}
            optionsList={optionsList}
            operatorList={operatorList}
            setOperatorList={setOperatorList}
            showOprater={showOprater}
            setShowOprater={setShowOprater}
            setFilterOprater={setFilterOprater}
            filterOprater={filterOprater}
            setFilterValueOptions={setFilterValueOptions}
            filterValueOptions={filterValueOptions}
            setServiceTypeShow={setServiceTypeShow}
            serviceTypeShow={serviceTypeShow}
            exportTable={exportTable}
            exportDownload={exportDownload}
            searchValueFilter={searchValueFilter}
            isSearching={isSearching} 
          />
        </TabPanel>

        <TabPanel id={1} activeTab={activeTab}>
          <Completed
            onTransferCount={transferCount}
            setAllCompletedCount={setAllCompletedCount}
            completedAppointments={completedAppointment}
            changeHandler={changeHandler}
            filterReset={filterReset}
            filterListAppointments={filterListCompletedAppointments}
            getPaginationData={(data) => getPaginationData(data, activeTab)}
            setFilterValues={setFilterValues}
            setSearchValues={setSearchValues}
            getAllAppointmentsList={getCompletedAppointments}
            actionData={actionData}
            setCompletedAppointments={setCompletedAppointments}
            activeTab={activeTab}
            completedAppointmentsPage={completedAppointmentsPage}
            completedAppointmentsrowsPerPage={completedAppointmentsrowsPerPage}
            searchValue={searchValue}
            filterValues={filterValues}
            serviceTypeList={serviceTypeList}
            changeHandlerFilter={changeHandlerFilter}
            serviceFilterValue={serviceFilterValue}
            setSortingNameOrderBy={setSortingNameOrderBy}
            setSortingTabType={setSortingTabType}
            setOptionsList={setOptionsList}
            optionsList={optionsList}
            operatorList={operatorList}
            setOperatorList={setOperatorList}
            showOprater={showOprater}
            setShowOprater={setShowOprater}
            setFilterOprater={setFilterOprater}
            filterOprater={filterOprater}
            setFilterValueOptions={setFilterValueOptions}
            filterValueOptions={filterValueOptions}
            setServiceTypeShow={setServiceTypeShow}
            serviceTypeShow={serviceTypeShow}
            exportTable={exportTable}
            exportDownload={exportDownload}
            searchValueFilter={searchValueFilter}
            isSearching={isSearching} 
          />
        </TabPanel>
        <TabPanel id={2} activeTab={activeTab}>
          <Cancelled
            onTransferCount={transferCount}
            setAllCancelledCount={setAllCancelledCount}
            setCanceledAppointments={setCanceledAppointments}
            canceledAppointment={canceledAppointment}
            changeHandler={changeHandler}
            filterReset={filterReset}
            filterListAppointments={filterListCancelledAppointments}
            getPaginationData={(data) => getPaginationData(data, activeTab)}
            setFilterValues={setFilterValues}
            setSearchValues={setSearchValues}
            cancelledAppointmentsPage={cancelledAppointmentsPage}
            cancelledAppointmentsrowsPerPage={cancelledAppointmentsrowsPerPage}
            searchValue={searchValue}
            filterValues={filterValues}
            serviceTypeList={serviceTypeList}
            changeHandlerFilter={changeHandlerFilter}
            serviceFilterValue={serviceFilterValue}
            setSortingNameOrderBy={setSortingNameOrderBy}
            setSortingTabType={setSortingTabType}
            getAllAppointmentsList={getCancelledAppointments}
            activeTab={activeTab}
            setOptionsList={setOptionsList}
            optionsList={optionsList}
            operatorList={operatorList}
            setOperatorList={setOperatorList}
            showOprater={showOprater}
            setShowOprater={setShowOprater}
            setFilterOprater={setFilterOprater}
            filterOprater={filterOprater}
            setFilterValueOptions={setFilterValueOptions}
            filterValueOptions={filterValueOptions}
            setServiceTypeShow={setServiceTypeShow}
            serviceTypeShow={serviceTypeShow}
            exportTable={exportTable}
            exportDownload={exportDownload}
            searchValueFilter={searchValueFilter}
            isSearching={isSearching} 
          />
        </TabPanel>
        <TabPanel id={3} activeTab={activeTab}>
          <NoShows
            onTransferCount={transferCount}
            setAllNoShowCount={setAllNoShowCount}
            setShowAppointments={setShowAppointments}
            showAppointment={showAppointment}
            changeHandler={changeHandler}
            filterReset={filterReset}
            filterListAppointments={filterListNoShowdAppointments}
            getPaginationData={(data) => getPaginationData(data, activeTab)}
            setFilterValues={setFilterValues}
            setSearchValues={setSearchValues}
            noshowAppointmentsPage={noshowAppointmentsPage}
            noshowAppointmentsrowsPerPage={noshowAppointmentsrowsPerPage}
            searchValue={searchValue}
            filterValues={filterValues}
            serviceTypeList={serviceTypeList}
            changeHandlerFilter={changeHandlerFilter}
            serviceFilterValue={serviceFilterValue}
            setSortingNameOrderBy={setSortingNameOrderBy}
            setSortingTabType={setSortingTabType}
            getAllAppointmentsList={getNoShowsAppointments}
            activeTab={activeTab}
            setOptionsList={setOptionsList}
            optionsList={optionsList}
            operatorList={operatorList}
            setOperatorList={setOperatorList}
            showOprater={showOprater}
            setShowOprater={setShowOprater}
            setFilterOprater={setFilterOprater}
            filterOprater={filterOprater}
            setFilterValueOptions={setFilterValueOptions}
            filterValueOptions={filterValueOptions}
            setServiceTypeShow={setServiceTypeShow}
            serviceTypeShow={serviceTypeShow}
            exportTable={exportTable}
            exportDownload={exportDownload}
            searchValueFilter={searchValueFilter}
            isSearching={isSearching} 
          />
        </TabPanel>
        <TabPanel id={4} activeTab={activeTab}>
          <RestrictedAppointments
            onTransferCount={transferCount}
            setAllRestrictedCount={setAllRestrictedCount}
            setRestrictedAppontmets={setRestrictedAppontmets}
            showAppointment={restrictedAppontmets}
            changeHandler={changeHandler}
            filterReset={filterReset}
            filterListAppointments={filterListRestrictedAppointments}
            getPaginationData={(data) => getPaginationData(data, activeTab)}
            setFilterValues={setFilterValues}
            setSearchValues={setSearchValues}
            restrictedAppointmentsPage={restrictedAppointmentsPage}
            restrictedAppointmentsrowsPerPage={
              restrictedAppointmentsrowsPerPage
            }
            searchValue={searchValue}
            filterValues={filterValues}
            serviceTypeList={serviceTypeList}
            changeHandlerFilter={changeHandlerFilter}
            serviceFilterValue={serviceFilterValue}
            setSortingNameOrderBy={setSortingNameOrderBy}
            setSortingTabType={setSortingTabType}
            getAllAppointmentsList={getRestrictedAppointments}
            activeTab={activeTab}
            setOptionsList={setOptionsList}
            optionsList={optionsList}
            operatorList={operatorList}
            setOperatorList={setOperatorList}
            showOprater={showOprater}
            setShowOprater={setShowOprater}
            setFilterOprater={setFilterOprater}
            filterOprater={filterOprater}
            setFilterValueOptions={setFilterValueOptions}
            filterValueOptions={filterValueOptions}
            setServiceTypeShow={setServiceTypeShow}
            serviceTypeShow={serviceTypeShow}
            exportTable={exportTable}
            exportDownload={exportDownload}
            searchValueFilter={searchValueFilter}
            isSearching={isSearching} 
          />
        </TabPanel>
        <TabPanel id={5} activeTab={activeTab}>
          <EndedEarlyAppointments
          onTransferCount={transferCount}
            setEndedEarlyCount={setEndedEarlyCount}
            setEndedEarlyAppontmets={setEndedEarlyAppontmets}
            showAppointment={endedEarlyAppontmets}
            changeHandler={changeHandler}
            filterListAppointments={filterListEndedEarlyAppointments}
            filterReset={filterReset}
            getPaginationData={(data) => getPaginationData(data, activeTab)}
            setFilterValues={setFilterValues}
            setSearchValues={setSearchValues}
            endedEarlyAppointmentsPage={endedEarlyAppointmentsPage}
            endedEarlyAppointmentsrowsPerPage={
              endedEarlyAppointmentsrowsPerPage
            }
            searchValue={searchValue}
            filterValues={filterValues}
            serviceTypeList={serviceTypeList}
            changeHandlerFilter={changeHandlerFilter}
            serviceFilterValue={serviceFilterValue}
            setSortingNameOrderBy={setSortingNameOrderBy}
            setSortingTabType={setSortingTabType}
            getAllAppointmentsList={getEndedEarlyAppointments}
            activeTab={activeTab}
            setOptionsList={setOptionsList}
            optionsList={optionsList}
            operatorList={operatorList}
            setOperatorList={setOperatorList}
            showOprater={showOprater}
            setShowOprater={setShowOprater}
            setFilterOprater={setFilterOprater}
            filterOprater={filterOprater}
            setFilterValueOptions={setFilterValueOptions}
            filterValueOptions={filterValueOptions}
            setServiceTypeShow={setServiceTypeShow}
            serviceTypeShow={serviceTypeShow}
            exportTable={exportTable}
            exportDownload={exportDownload}
            searchValueFilter={searchValueFilter}
            isSearching={isSearching} 
          />
        </TabPanel>

        <TabPanel id={6} activeTab={activeTab}>
          <Ongoing
            showOngoingAppointments={showOngoingAppointments}
            changeHandler={changeHandler}
            filterReset={filterReset}
            filterListAppointments={() => { }}
            getPaginationData={(data) => getPaginationData(data, activeTab)}
            setFilterValues={setFilterValues}
            setSearchValues={setSearchValues}
            ongoingAppointmentsPage={ongoingAppointmentsPage}
            ongoingAppointmentsrowsPerPage={ongoingAppointmentsrowsPerPage}
            searchValue={searchValue}
            filterValues={filterValues}
            serviceTypeList={serviceTypeList}
            changeHandlerFilter={changeHandlerFilter}
            serviceFilterValue={serviceFilterValue}
            setSortingNameOrderBy={setSortingNameOrderBy}
            setSortingTabType={setSortingTabType}
            optionsList={optionsList}
            operatorList={operatorList}
            setOperatorList={setOperatorList}
            showOprater={showOprater}
            setShowOprater={setShowOprater}
            setFilterOprater={setFilterOprater}
            filterOprater={filterOprater}
            setFilterValueOptions={setFilterValueOptions}
            filterValueOptions={filterValueOptions}
            setServiceTypeShow={setServiceTypeShow}
            serviceTypeShow={serviceTypeShow}
            exportTable={exportTable}
            exportDownload={exportDownload}
            searchValueFilter={searchValueFilter}
            isSearching={isSearching} 
          />
        </TabPanel>
      </ul>
      {/* <Pagination  rowsPerPageOptions={[5, 10, 25]}  count={100} getPaginationData={getPaginationData} /> */}
    </div>
  );
}
